// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-22T20:07:13.085Z
// Property: Liberty Pointe (ID: 6767906449166328)
// Collections: 27 amenities, 13 floorplans (live), 31 photos, 78 POIs, 1 reviews, 2 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162442",
  "multihub_property_id": "6767906449166328",
  "property_external_id": "30923",
  "property_zillow_url": "https://www.zillow.com/apartments/newark-de/liberty-pointe/ChqSxz/",
  "property_apartments_url": "https://www.apartments.com/liberty-pointe-newark-de/hcj3vr2/",
  "property_google_business_url": "https://www.google.com/maps/place/Liberty+Pointe+Apartment+Homes/data=!4m2!3m1!1s0x0:0x4f638fab8672cfd1?sa=X&ved=2ahUKEwiPlMLBu7iSAxW2mmoFHX1ABQYQ_BJ6BAgXEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "47607690395",
  "property_crm_software": "EliseAI",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "liberty-pointe",
  "property_name": "Liberty Pointe",
  "property_website_url": "https://www.livelibertypointe.com/",
  "property_domain": "https://www.livelibertypointe.com/",
  "property_address": "816 Lawrence Drive",
  "property_full_address": "816 Lawrence Dr, Newark, DE 19702",
  "property_address_1": "816 Lawrence Dr",
  "property_address_2": null,
  "property_address_city": "Newark",
  "property_address_state": "DE",
  "property_address_zip_full": "19702-1694",
  "property_address_zip": "19702",
  "property_address_country": "US",
  "property_address_county": "New Castle County",
  "property_neighborhood_address": "Southern New Castle County",
  "property_address_latitude": "39.66650080000001",
  "property_address_longitude": "-75.6740294",
  "property_email": "libertypointe@aionmanagement.com",
  "property_phone": "(302) 366-8000",
  "property_call_tracking_phone": "855-305-6434",
  "property_company_name": "AION Management ",
  "property_company_url": "https://www.aionmanagement.com",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "At Liberty Pointe in Newark, DE, modern living meets unbeatable convenience. Choose from our stylish studio, one, or two-bedroom apartments featuring sleek renovations and exceptional amenities, including a dog park, fitness center, and deposit-free community. Embrace a vibrant lifestyle—schedule your tour today to experience your future home!",
  "property_long_description": "Welcome to Liberty Pointe, your serene sanctuary in the heart of Newark, DE! Our vibrant apartment community offers a variety of spacious floor plans, including stylish studios, cozy one-bedroom, and generous two-bedroom options tailored to fit your lifestyle. At Liberty Pointe, we prioritize your comfort and convenience with a deposit-free living experience and a range of premium amenities designed to enhance your everyday life.\n\nStay active at our state-of-the-art fitness center or enjoy outdoor fun at our grilling and picnic area and dog park. Families will appreciate our playground, while residents of all ages can partake in our engaging resident activities. Take advantage of our controlled-access buildings, ensuring peace of mind alongside the convenience of walking distance to public transportation.\n\nOur renovated apartments feature modern solutions such as in-home washer and dryer, sleek espresso cabinets, energy-efficient windows, and enhanced bathrooms with stylish lighting. Choose from fully furnished options, and enjoy the convenience of online rent payment and maintenance requests, along with 24-hour emergency maintenance for your peace of mind.\n\nLocated just five minutes from the popular Christiana Mall, Liberty Pointe offers the perfect blend of comfort and convenience. Plus, with free resident parking and flexible payment options, we’re here to make your living experience as seamless as possible.\n\nDon’t miss your chance to call Liberty Pointe home! Explore our availability or schedule a tour today and discover your perfect apartment in Newark, DE!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019fd912-5199-7059-94bc-02bc50e2deb9.webp",
  "property_featured_image_media": {
    "alt_text": "Kitchen with dark wood cabinets, black appliances, and a sink.",
    "public_id": "019fd912-5199-7059-94bc-02bc50e2deb9",
    "storage_key": "property/6767906449166328/019fd912-5199-7059-94bc-02bc50e2deb9.webp",
    "width": 984,
    "height": 656
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "136",
  "property_year_built": "1969",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "98.52941176470588",
  "property_admin_fee": null,
  "property_application_fee": "75",
  "property_fees_deposit_info": "Security Deposit: $750",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "350",
  "property_pet_deposit": "350",
  "property_monthly_pet_rent": "50",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "75",
  "property_pet_restrictions": "Maximum 2 pets per apartment, each up to 75 lb.",
  "property_pet_policy_description": "We’re a pet-friendly community and we’re happy to welcome your cats and dogs. Breed restrictions apply; please contact the leasing office for details. You can have up to 2 pets per apartment, with each pet up to 75 lb. There is a one-time, non-refundable pet fee of $350 and monthly pet rent is $25.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://libertypointenewark.loftliving.com/login",
  "property_apply_now_url": "https://www.livelibertypointe.com/apply-now",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/01a05d3c-5912-72da-ae44-795c53c83133.webp",
  "property_primary_logo_media": {
    "alt_text": "Liberty Pointe Apartment Homes logo",
    "public_id": "01a05d3c-5912-72da-ae44-795c53c83133",
    "storage_key": "property/6767906449166328/01a05d3c-5912-72da-ae44-795c53c83133.webp",
    "width": 499,
    "height": 230
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/01a05d21-7fe5-771c-b9f3-a2c5fa88ba58.webp",
  "property_secondary_logo_media": {
    "alt_text": "Liberty Pointe Apartment Homes logo.",
    "public_id": "01a05d21-7fe5-771c-b9f3-a2c5fa88ba58",
    "storage_key": "property/6767906449166328/01a05d21-7fe5-771c-b9f3-a2c5fa88ba58.webp",
    "width": 792,
    "height": 612
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/01a05d3c-5911-776a-9954-348ed97fa2a3.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Liberty Pointe Apartment Homes logo",
    "public_id": "01a05d3c-5911-776a-9954-348ed97fa2a3",
    "storage_key": "property/6767906449166328/01a05d3c-5911-776a-9954-348ed97fa2a3.webp",
    "width": 500,
    "height": 235
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/01a05d3c-5912-72da-ae44-795c53c83133.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Liberty Pointe Apartment Homes logo",
    "public_id": "01a05d3c-5912-72da-ae44-795c53c83133",
    "storage_key": "property/6767906449166328/01a05d3c-5912-72da-ae44-795c53c83133.webp",
    "width": 499,
    "height": 230
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162442/019fcb00-e4bd-730e-be09-fdc89126e5de.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162442/019d0264-670c-7240-a629-183122c7de9e.webp",
  "property_company_logo_media": {
    "alt_text": "AION MANAGEMENT logo",
    "public_id": "019d0264-670c-7240-a629-183122c7de9e",
    "storage_key": "company/5767906449162442/019d0264-670c-7240-a629-183122c7de9e.webp",
    "width": 598,
    "height": 250
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#002142",
  "property_secondary_color": "#494747",
  "property_font_color": "#002142",
  "property_color_4": null,
  "property_color_3": "#f18c20",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "studio - 2",
  "property_bedrooms_min": "studio",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "418 - 855",
  "property_sqft_min": "418",
  "property_sqft_max": "855",
  "property_price_range": "1446 - 1768",
  "property_price_min": "1446",
  "property_price_max": "1768",
  "property_available_units": 2,
  "property_facebook_url": "https://www.facebook.com/LibertyPointeApts/",
  "property_instagram_url": "https://www.instagram.com/libertypointe/?hl=en",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJZYVtYdEAx4kR0c9yhquPY08",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/search?find_desc=Apartments&find_loc=New+Castle%2C+DE+19720",
  "property_tiktok_url": "https://www.tiktok.com/@liberty_pointe_apts",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Liberty Pointe",
  "property_home_romance_title": "Embrace the Joy of Living in Your Perfect Home",
  "property_home_amenities_blurb": "Welcome to Liberty Pointe in Newark, DE, where modern living meets convenience. Our deposit-free community offers stylish one and two-bedroom apartments and studios, complete with renovated kitchens and spacious living areas. Enjoy premium amenities like a fitness center, playground, and a dog park—all just minutes from Christiana Mall!",
  "property_home_floorplans_blurb": "Welcome to Liberty Pointe in Newark, DE, where modern living meets comfort. Choose from stylish studio, one-bedroom, or spacious two-bedroom apartments designed for your lifestyle. Browse our diverse floor plans now to find the ideal space that perfectly fits your needs and aspirations in this vibrant community.",
  "property_home_gallery_blurb": "At Liberty Pointe in Newark, DE, your ideal lifestyle awaits with stylish one-bedroom, two-bedroom, and studio apartments. Enjoy modern amenities like a deposit-free community, fitness center, and dog park, all within walking distance of public transportation. Picture yourself living here, where comfort and convenience meet!",
  "property_home_neighborhood_blurb": "At Liberty Pointe in Newark, DE, your dream lifestyle awaits among vibrant community gems. Embrace outdoor adventures at White Clay Creek State Park or enjoy enriching experiences at the nearby University of Delaware. With spacious one-bedroom, two-bedroom, and studio floor plans available, the best of comfort and convenience is just a click away!",
  "property_home_reviews_blurb": "At Liberty Pointe in Newark, DE, residents appreciate our fantastic maintenance service, ensuring their homes are always in top shape. With a commitment to community care, we create a welcoming atmosphere that keeps our residents happy. Join a vibrant community where your voice matters! See what our residents have to say about living at our community!",
  "property_neighborhood_blurb": "At Liberty Pointe in Newark, DE, vibrant living intertwines with lush surroundings. Unwind at White Clay Creek State Park or catch a show at the nearby Thompson Theatre. With top schools and esteemed institutions like the University of Delaware just moments away, your ideal lifestyle is within reach. Experience the heartbeat of the community!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Liberty Pointe in Newark, DE, enjoy a vibrant lifestyle with deposit-free living and an array of amenities like a state-of-the-art fitness center, dog park, and playground. Relax in stylish, renovated apartments equipped with modern comforts. Whether you choose a studio or a spacious two-bedroom, your perfect home awaits!",
  "property_applynow_blurb": "At Liberty Pointe in Newark, DE, you’ll find the perfect balance of comfort and convenience. Choose from stylish one and two-bedroom apartments or cozy studios, all featuring modern amenities like in-home washers, updated kitchens, and a dog park. Experience a deposit-free community tailored for your lifestyle—apply now to secure your new home!",
  "property_contactus_blurb": "At Liberty Pointe in Newark, DE, our diverse floor plans offer the perfect fit for everyone, from cozy studios to spacious one- and two-bedroom apartments. Have questions? Our friendly leasing team is ready to help you find your ideal living space. Reach out today and take the first step towards your new home!",
  "property_faqs_blurb": "At Liberty Pointe in Newark, DE, we understand that your lifestyle is unique. Whether you're seeking the compact charm of a studio, the spacious comfort of a one-bedroom, or the versatility of a two-bedroom apartment, we have the perfect floor plan for you. Curious about our community? Browse our FAQs page for answers!",
  "property_floorplans_blurb": "At Liberty Pointe in Newark, DE, we offer a range of thoughtfully designed floor plans, including cozy studios, spacious one-bedroom, and inviting two-bedroom apartments. Each layout is crafted for comfort and style. Browse our available apartment homes to find the perfect space that suits your lifestyle!",
  "property_gallery_blurb": "At Liberty Pointe in Newark, DE, vibrant living meets modern comfort. Picture yourself enjoying spacious floor plans, including stylish studios and two-bedroom apartments. With amenities like a pet-friendly dog park, a fully-equipped fitness center, and renovated kitchens, your dream home is just a click away! Your new adventure starts here!",
  "property_interactivemap_blurb": "At Liberty Pointe in Newark, DE, your ideal living space awaits! With stylish one-bedroom, two-bedroom, and studio options, our deposit-free community boasts a wealth of amenities. From a fitness center and dog park to renovated kitchens, you’ll enjoy comfort and convenience. Use our interactive map to find your perfect home!",
  "property_pets_blurb": "At Liberty Pointe in Newark, DE, your pets are part of the family. Embrace comfort and community in our spacious apartments, where cats and dogs thrive. With ample green space and a welcoming atmosphere, you and your furry friends will love calling Liberty Pointe home.",
  "property_referafriend_blurb": "At Liberty Pointe in Newark, DE, we believe great friends make great neighbors! With spacious one-bedroom, two-bedroom, and studio floor plans, our community is perfectly designed for connection and comfort. Refer a friend today and let the joy of communal living thrive together! ",
  "property_residentaccess_blurb": "Welcome to Liberty Pointe in Newark, DE! Access your resident portal for seamless services like rent payments and maintenance requests. Choose from our stylish studio, one, or two-bedroom floor plans that embody comfortable living. Your community awaits—log in for convenience at your fingertips!",
  "property_reviews_blurb": "At Liberty Pointe in Newark, DE, residents rave about our \"fantastic\" maintenance team that promptly addresses apartment issues. Enjoy a thriving community where your comfort matters. Hear from our residents about the vibrant living experience and see why so many choose to call Liberty Pointe home!",
  "property_created_at": "1757006696272",
  "property_scheduletour_blurb": "At Liberty Pointe in Newark, DE, find your perfect home among our diverse floor plans, including one-bedroom, two-bedroom, and stylish studios. Embrace a vibrant lifestyle and stunning community amenities. Curious about living here? Schedule a tour today and hear firsthand from our residents about their experiences!",
  "property_thankyou_blurb": "Thank you for reaching out to Liberty Pointe in Newark, DE! With a variety of thoughtfully designed floor plans, including cozy studios, spacious one-bedroom, and inviting two-bedroom apartments, we’re excited to help you find your perfect fit. Our team will be in touch soon to guide you on your journey home!",
  "property_virtualtours_blurb": "At Liberty Pointe in Newark, DE, your ideal living space awaits! Whether you prefer a cozy studio, a spacious one-bedroom, or a versatile two-bedroom, our thoughtfully designed floor plans cater to every lifestyle. Take a virtual tour today and envision your new home amidst our vibrant community!",
  "property_copyright": "2025 All Rights Reserved. Liberty Pointe",
  "property_seo_title_home": "Liberty Pointe | Newark, DE Apartments",
  "property_seo_description_home": "Experience luxury living at Liberty Pointe in Newark, DE. We offer Studio, 1 & 2-bedroom pet-friendly apartments to fit your every need.",
  "property_seo_title_floorplans": "Floor Plans | Newark, DE Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal home at Liberty Pointe in Newark, DE! Choose from stylish studios, one, or two-bedroom layouts. Browse our floor plans today!",
  "property_seo_title_amenities": "Amenities | Newark, DE Apartments for Rent",
  "property_seo_description_amenities": "Experience modern living at Liberty Pointe! Enjoy deposit-free apartments, a fitness center, dog park, and more—all in Newark, DE. Your new home awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in Newark, DE",
  "property_seo_description_gallery": "Experience life at Liberty Pointe in Newark, DE. From chic studios to spacious two-bedrooms, enjoy amenities like a dog park, fitness center, and more!",
  "property_seo_title_virtualtours": "Virtual Tours | Liberty Pointe Apartments",
  "property_seo_description_virtualtours": "Experience Liberty Pointe in Newark, DE—home to stylish studios, one and two-bedroom apartments. Take a virtual tour today and envision your new lifestyle!",
  "property_seo_title_interactivemap": "Interactive Map | Liberty Pointe Apartments",
  "property_seo_description_interactivemap": "Find your perfect home at Liberty Pointe in Newark, DE! Enjoy pet-friendly living with modern amenities, a wellness center, and a community focused on you.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Newark, DE",
  "property_seo_description_neighborhood": "Uncover the charm of Newark, DE at Liberty Pointe! Enjoy vibrant local favorites, scenic parks, and unique shops—all just steps from your new home.",
  "property_seo_title_contact": "Contact Us | Liberty Pointe",
  "property_seo_description_contact": "Reach out to Liberty Pointe in Newark, DE! Whether it's about our one-bedroom, two-bedroom, or studio apartments, our leasing team is here to help!",
  "property_seo_title_faqs": "FAQs | Apartments in Newark, DE",
  "property_seo_description_faqs": "Find answers to your questions about Liberty Pointe in Newark, DE! Discover our deposit-free living, fantastic amenities, and pet-friendly options today!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Newark, DE",
  "property_seo_description_reviews": "Experience unmatched living at Liberty Pointe in Newark, DE. Read resident reviews and see why our community, amenities, and vibrant lifestyle stand out!",
  "property_seo_title_applynow": "Apply Now | Apartments in Newark, DE",
  "property_seo_description_applynow": "Experience modern living at Liberty Pointe in Newark, DE. Choose from stylish one & two-bedroom apartments with first-class amenities. Lease online today!",
  "property_seo_title_residentaccess": "Resident Access | Liberty Pointe",
  "property_seo_description_residentaccess": "Unlock convenience at Liberty Pointe! Log in to your resident portal for hassle-free rent payments, maintenance requests, and community updates. Welcome home!",
  "property_seo_title_referafriend": "Refer A Friend | Liberty Pointe",
  "property_seo_description_referafriend": "At Liberty Pointe in Newark, DE, great friends mean great neighbors! Refer a friend and enjoy the perks of community living together. Join us today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Liberty Pointe",
  "property_seo_description_scheduletour": "Experience the charm of Liberty Pointe in Newark, DE. Schedule a tour today and imagine your new lifestyle in our vibrant apartment community!",
  "property_seo_title_privacy": "Privacy Policy | Liberty Pointe",
  "property_seo_description_privacy": "At Liberty Pointe in Newark, DE, your privacy matters. Learn how we safeguard your information and ensure a secure living experience. View our privacy policy.",
  "property_seo_title_accessibility": "Website Accessibility | Liberty Pointe",
  "property_seo_description_accessibility": "At Liberty Pointe in Newark, DE, we prioritize accessibility for all. Join our community where everyone is welcome and digital inclusion is a commitment.",
  "property_seo_title_sitemap": "Sitemap | Liberty Pointe",
  "property_seo_description_sitemap": "Uncover the pathways to your future at Liberty Pointe in Newark, DE. Navigate our sitemap for an easy journey to your next apartment home today!",
  "property_seo_title_thankyou": "Thank You | Liberty Pointe",
  "property_seo_description_thankyou": "Thank you for reaching out to Liberty Pointe in Newark, DE! Our team will connect with you soon. Embrace a vibrant community and a new chapter awaits!",
  "property_seo_title_pets": null,
  "property_seo_description_pets": null,
  "property_updated_at": "1792695642492",
  "amenities": [
    {
      "id": "custom_15af8c90-fe91-4cfe-b5ac-c750756ed59c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "external_id": "false",
      "title": "Controlled Access Buildings",
      "amount": "false",
      "description": "",
      "group": "Indoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_46083d1f-b8c0-4bc1-b84c-c43460048cfd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "external_id": "false",
      "title": "Fitness Center",
      "amount": "false",
      "description": "",
      "group": "Indoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_541f1e0d-2ccb-4111-aafd-b8e6b6727edf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "external_id": "false",
      "title": "Online Maintenance Requests",
      "amount": "false",
      "description": "",
      "group": "Indoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_420d84cf-57ea-4aa6-99dc-6940753deebd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "external_id": "false",
      "title": "Online Rent Payments & Resident Portal",
      "amount": "false",
      "description": "",
      "group": "Indoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1495913c-9d41-4079-a448-bcc77932e5df",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "external_id": "false",
      "title": "On-Site Maintenance",
      "amount": "false",
      "description": "",
      "group": "Indoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4d1bf29d-72f8-4a9e-8e3a-8dac0e9b9ecd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "external_id": "false",
      "title": "On-Site Management",
      "amount": "false",
      "description": "",
      "group": "Indoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a3d5c764-934c-4135-8623-fd27e8a6af2b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "external_id": "false",
      "title": "Pet Friendly",
      "amount": "false",
      "description": "",
      "group": "Indoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_58456613-066d-408b-a025-cd05d7c85757",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "external_id": "false",
      "title": "Central Air Conditioning",
      "amount": "false",
      "description": "",
      "group": "In-Home Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_361ca8eb-9ba5-4aa2-a4fc-d24ef1aa34ec",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "external_id": "false",
      "title": "In-Home Washer & Dryer",
      "amount": "false",
      "description": "",
      "group": "In-Home Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_059ee3ee-a461-4366-9fd9-4d5d8c6598a4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "external_id": "false",
      "title": "Renovated Kitchens*",
      "amount": "false",
      "description": "",
      "group": "In-Home Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d5288881-80bb-4d88-9e96-049827ee7c9a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "external_id": "false",
      "title": "Stainless Steel Appliances*",
      "amount": "false",
      "description": "",
      "group": "In-Home Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e8e2fb8d-e865-4ae4-bbe8-8d877ce786da",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "external_id": "false",
      "title": "Black Appliances*",
      "amount": "false",
      "description": "",
      "group": "In-Home Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4ad4269b-13b7-48f9-9e79-73f86470cd36",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "external_id": "false",
      "title": "Built-In Microwave*",
      "amount": "false",
      "description": "",
      "group": "In-Home Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_983b668c-97c1-43c1-83f8-386a285547a3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "external_id": "false",
      "title": "Dishwasher",
      "amount": "false",
      "description": "",
      "group": "In-Home Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8a717cd8-ea93-4a8f-85f8-9c71fd49a3f7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "external_id": "false",
      "title": "Renovated Bathrooms*",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a2bcc267-2c8b-42d6-a82d-d23c89b59859",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "external_id": "false",
      "title": "Modern White Cabinets*",
      "amount": "false",
      "description": "",
      "group": "In-Home Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5cf78e49-af66-4552-bc84-442b8c9d1546",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "external_id": "false",
      "title": "Espresso Cabinets*",
      "amount": "false",
      "description": "",
      "group": "In-Home Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f8791bc5-05a0-4e8e-b8fb-dc605d47435b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "external_id": "false",
      "title": "Large Closets",
      "amount": "false",
      "description": "",
      "group": "In-Home Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_17849f56-093a-4614-8e0e-e2cee07b6f75",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "external_id": "false",
      "title": "Plank Flooring in Kitchens*",
      "amount": "false",
      "description": "",
      "group": "In-Home Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f4e63788-6710-4d98-90e3-865bfc49d150",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "external_id": "false",
      "title": "Window Coverings",
      "amount": "false",
      "description": "",
      "group": "In-Home Features",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2cdfa632-eb7e-47c2-adce-56c0ff4c90f4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "external_id": "false",
      "title": "Walking Distance to Public Transportation",
      "amount": "false",
      "description": "",
      "group": "Neighborhood",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ee7d091b-e863-48dd-ab33-2245310329ea",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "external_id": "false",
      "title": "5 Minutes to Christiana Mall",
      "amount": "false",
      "description": "",
      "group": "Neighborhood",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_525cc479-7d09-4f0c-80a4-adae60e0bf59",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "external_id": "false",
      "title": "Dog Park",
      "amount": "false",
      "description": "",
      "group": "Outdoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3132257d-ed99-4cd8-8e7b-c084f1b04cf6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "external_id": "false",
      "title": "Free Resident Parking",
      "amount": "false",
      "description": "",
      "group": "Outdoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ac1e9ab0-32e7-4d2b-9f60-8859e6b07070",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "external_id": "false",
      "title": "Grilling & Picnic Area",
      "amount": "false",
      "description": "",
      "group": "Outdoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9374e029-7e7f-4592-a599-df6e30211f1e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "external_id": "false",
      "title": "Playground",
      "amount": "false",
      "description": "",
      "group": "Outdoor Amenities",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d3ae41e1-e5b8-4ae6-872a-cd9eaf1759ff",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "external_id": "false",
      "title": "Walking Distance to Shopping, Dining, Banking, & Other Daily Essentials",
      "amount": "false",
      "description": "",
      "group": "Neighborhood",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_3a83c3fe-05e7-437f-baa9-f7e42e4d93a2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019fd923-a1be-756d-b6bd-a8b11c2c849d.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, black appliances, and a window overlooking trees.",
        "public_id": "019fd923-a1be-756d-b6bd-a8b11c2c849d",
        "storage_key": "property/6767906449166328/019fd923-a1be-756d-b6bd-a8b11c2c849d.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Featured",
      "link": "false",
      "alt_text": "Kitchen with dark wood cabinets, black stove and microwave, granite countertops, and a window over the sink at Liberty Pointe in Newark, DE.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/898c847a/dms3rep/multi/opt/5767906449162442/6767906449166328/b14dafe0d3b5806a1262c6ec917db991-1920w.jpg"
    },
    {
      "id": "custom_1825eadb-4199-491a-bc3d-0dbb88b9e3ed",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019fd923-a1be-756d-b6bd-ae0c02c4ece1.webp",
      "image_media": {
        "alt_text": "Living room and dining room with a sectional sofa, coffee table, and dining set.",
        "public_id": "019fd923-a1be-756d-b6bd-ae0c02c4ece1",
        "storage_key": "property/6767906449166328/019fd923-a1be-756d-b6bd-ae0c02c4ece1.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Interior living room with beige walls, a wall-mounted TV, sofa, coffee table, dining table, and a coat closet at Liberty Pointe in Newark, DE.",
      "link": "false",
      "alt_text": "Interior living room with beige walls, a wall-mounted TV, sofa, coffee table, dining table, and a coat closet at Liberty Pointe in Newark, DE.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/898c847a/dms3rep/multi/opt/5767906449162442/6767906449166328/a1cf9b2411f872af7751db3d2da77751-1920w.jpg"
    },
    {
      "id": "custom_df4afebb-3bf6-47d1-beb6-a293588edf6d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019fd923-a1e4-71ea-91dd-e0c70302c48f.webp",
      "image_media": {
        "alt_text": "Living room with a sectional sofa, coffee table, and TV.",
        "public_id": "019fd923-a1e4-71ea-91dd-e0c70302c48f",
        "storage_key": "property/6767906449166328/019fd923-a1e4-71ea-91dd-e0c70302c48f.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Living room in a modern apartment with a gray sectional, coffee table, and a large window at Liberty Pointe in Newark, DE.",
      "link": "false",
      "alt_text": "Living room in a modern apartment with a gray sectional, coffee table, and a large window at Liberty Pointe in Newark, DE.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/898c847a/dms3rep/multi/opt/5767906449162442/6767906449166328/38b84bd0c3d931c19189c1d403bf6620-1920w.jpg"
    },
    {
      "id": "custom_21ea0d2b-8a88-427d-a074-224638257324",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019fd923-a321-765d-bd47-923c13bbea5d.webp",
      "image_media": {
        "alt_text": "Bedroom with a large bed, TV, and dresser.",
        "public_id": "019fd923-a321-765d-bd47-923c13bbea5d",
        "storage_key": "property/6767906449166328/019fd923-a321-765d-bd47-923c13bbea5d.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Bedroom in a contemporary apartment with a large bed, wall-mounted TV, dresser, and window at Liberty Pointe in Newark, DE.",
      "link": "false",
      "alt_text": "Bedroom in a contemporary apartment with a large bed, wall-mounted TV, dresser, and window at Liberty Pointe in Newark, DE.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/898c847a/dms3rep/multi/opt/5767906449162442/6767906449166328/9aa95b8fa97aa23413fc12a888b98a22-1920w.jpg"
    },
    {
      "id": "custom_e664c670-c493-418e-80f0-44969d6fedec",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019fd923-ad71-75fe-a928-53d00c1c6c5f.webp",
      "image_media": {
        "alt_text": "Kitchen with stainless steel appliances, white cabinets, and granite countertops.",
        "public_id": "019fd923-ad71-75fe-a928-53d00c1c6c5f",
        "storage_key": "property/6767906449166328/019fd923-ad71-75fe-a928-53d00c1c6c5f.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Modern apartment kitchen with white cabinets, stainless steel appliances, and a window above the sink at Liberty Pointe in Newark, DE.",
      "link": "false",
      "alt_text": "Modern apartment kitchen with white cabinets, stainless steel appliances, and a window above the sink at Liberty Pointe in Newark, DE.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/898c847a/dms3rep/multi/opt/5767906449162442/6767906449166328/2bdd2a43b7ee9defc763da335222e75c-1920w.jpg"
    },
    {
      "id": "custom_441359bd-46c8-49e0-ac50-eb0978ff25f1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019fd923-adfd-72d9-adac-55a4b445285e.webp",
      "image_media": {
        "alt_text": "Spacious living room with a large sectional sofa, coffee table, and a television.",
        "public_id": "019fd923-adfd-72d9-adac-55a4b445285e",
        "storage_key": "property/6767906449166328/019fd923-adfd-72d9-adac-55a4b445285e.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "L-shaped beige living room with a sofa, coffee table, and a large window with vertical blinds at Liberty Pointe in Newark, DE.",
      "link": "false",
      "alt_text": "L-shaped beige living room with a sofa, coffee table, and a large window with vertical blinds at Liberty Pointe in Newark, DE.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/898c847a/dms3rep/multi/opt/5767906449162442/6767906449166328/085f2aab3c08e01a10357c1ac2702394-1920w.jpg"
    },
    {
      "id": "custom_632ca933-b190-482d-a86a-7a3b97edb1ad",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019fd923-ade4-74cc-bf0f-3ed820cc7928.webp",
      "image_media": {
        "alt_text": "Modern bedroom with a king-size bed, open closet with shelves, dresser, and television.",
        "public_id": "019fd923-ade4-74cc-bf0f-3ed820cc7928",
        "storage_key": "property/6767906449166328/019fd923-ade4-74cc-bf0f-3ed820cc7928.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Bedroom interior with a bed featuring gray bedding, a dresser, and an open closet nook at Liberty Pointe in Newark, DE.",
      "link": "false",
      "alt_text": "Bedroom interior with a bed featuring gray bedding, a dresser, and an open closet nook at Liberty Pointe in Newark, DE.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/898c847a/dms3rep/multi/opt/5767906449162442/6767906449166328/c98f74c7accd73657d1a59fe0685f060-1920w.jpg"
    },
    {
      "id": "custom_0b26f63d-3165-4e68-9a39-8459c02f0678",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019fd923-b87c-7659-b9d0-a6a442ca436f.webp",
      "image_media": {
        "alt_text": "Bedroom with a large bed, dresser, and a television.",
        "public_id": "019fd923-b87c-7659-b9d0-a6a442ca436f",
        "storage_key": "property/6767906449166328/019fd923-b87c-7659-b9d0-a6a442ca436f.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Bedroom in a modern apartment featuring a large bed, dresser, bench, and window with blinds at Liberty Pointe in Newark, DE.",
      "link": "false",
      "alt_text": "Bedroom in a modern apartment featuring a large bed, dresser, bench, and window with blinds at Liberty Pointe in Newark, DE.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/898c847a/dms3rep/multi/opt/5767906449162442/6767906449166328/602f42e3ccf5a4fafe71783509ee46d5-1920w.jpg"
    },
    {
      "id": "custom_9b49c8cf-5f11-4367-b688-5ec4c43b276c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019fd923-b8dc-71ea-b1cd-d09bfb620a46.webp",
      "image_media": {
        "alt_text": "Bedroom with a wall-mounted TV, dresser, and mirror.",
        "public_id": "019fd923-b8dc-71ea-b1cd-d09bfb620a46",
        "storage_key": "property/6767906449166328/019fd923-b8dc-71ea-b1cd-d09bfb620a46.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Bedroom in a modern apartment with a dresser, TV, and window blinds at Liberty Pointe in Newark, DE.",
      "link": "false",
      "alt_text": "Bedroom in a modern apartment with a dresser, TV, and window blinds at Liberty Pointe in Newark, DE.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/898c847a/dms3rep/multi/opt/5767906449162442/6767906449166328/8d7cc90daf37a25bc4c5934b394771fd-1920w.jpg"
    },
    {
      "id": "custom_1d3c9961-aa5f-485c-877b-db1b195624ec",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019fd923-bba3-77e9-8db9-9accf0a0d894.webp",
      "image_media": {
        "alt_text": "Dining area with an oval table, four chairs, and a ceiling fan.",
        "public_id": "019fd923-bba3-77e9-8db9-9accf0a0d894",
        "storage_key": "property/6767906449166328/019fd923-bba3-77e9-8db9-9accf0a0d894.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Dining area with oval table, chairs, beige walls, and a ceiling fan at Liberty Pointe in Newark, DE.",
      "link": "false",
      "alt_text": "Dining area with oval table, chairs, beige walls, and a ceiling fan at Liberty Pointe in Newark, DE.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/898c847a/dms3rep/multi/opt/5767906449162442/6767906449166328/c59c52806461a98d0c408c4de08dcb35-1920w.jpg"
    },
    {
      "id": "custom_a9638242-a2dc-4df3-81a6-47eb199e158c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019fd923-bf3b-724d-b802-d61b3b50b235.webp",
      "image_media": {
        "alt_text": "Living room with sectional sofa, coffee table, and mounted TV.",
        "public_id": "019fd923-bf3b-724d-b802-d61b3b50b235",
        "storage_key": "property/6767906449166328/019fd923-bf3b-724d-b802-d61b3b50b235.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Living room in a modern apartment with a gray sectional sofa, round black coffee table, and wall-mounted TV at Liberty Pointe in Newark, DE.",
      "link": "false",
      "alt_text": "Living room in a modern apartment with a gray sectional sofa, round black coffee table, and wall-mounted TV at Liberty Pointe in Newark, DE.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/898c847a/dms3rep/multi/opt/5767906449162442/6767906449166328/21c31055a62310d0719e4794fb3f936c-1920w.jpg"
    },
    {
      "id": "custom_3c9394e2-ac35-4d59-b7c3-820554a3fc62",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019fd923-c456-756e-8521-90b80b083d17.webp",
      "image_media": {
        "alt_text": "Living room with a sofa, coffee table, and dining area.",
        "public_id": "019fd923-c456-756e-8521-90b80b083d17",
        "storage_key": "property/6767906449166328/019fd923-c456-756e-8521-90b80b083d17.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Featured",
      "link": "false",
      "alt_text": "Living room in an apartment with a gray sofa, round coffee table, TV, and dining area at Liberty Pointe in Newark, DE.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/898c847a/dms3rep/multi/opt/5767906449162442/6767906449166328/8ca97ae5f86f3dadf290d374a0e8c6a5-1920w.jpg"
    },
    {
      "id": "custom_3064d7f9-8125-4d0f-a11b-60ab7b516c18",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019fd923-c58f-716b-9a31-46ad670a2ff1.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, dresser, and a walk-in closet.",
        "public_id": "019fd923-c58f-716b-9a31-46ad670a2ff1",
        "storage_key": "property/6767906449166328/019fd923-c58f-716b-9a31-46ad670a2ff1.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Featured",
      "link": "false",
      "alt_text": "Bedroom in an apartment with a bed, dresser, lamp, and doorway at Liberty Pointe in Newark, DE.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/898c847a/dms3rep/multi/opt/5767906449162442/6767906449166328/fae3696ca0aea133b89809fd99e5c267-1920w.jpg"
    },
    {
      "id": "custom_badf72a3-bfe1-4c66-9418-a1561a6a4edf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019fd923-c794-7639-923c-afb6b5fd20f1.webp",
      "image_media": {
        "alt_text": "Modern bathroom vanity with a sink, faucet, mirror, and towel ring.",
        "public_id": "019fd923-c794-7639-923c-afb6b5fd20f1",
        "storage_key": "property/6767906449166328/019fd923-c794-7639-923c-afb6b5fd20f1.webp",
        "width": 1335,
        "height": 2000
      },
      "title": "Apartment",
      "description": "Bathroom vanity with white sink, black faucet, large framed mirror, towel ring, and gray accessories at Liberty Pointe in Newark, DE.",
      "link": "false",
      "alt_text": "Bathroom vanity with white sink, black faucet, large framed mirror, towel ring, and gray accessories at Liberty Pointe in Newark, DE.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/898c847a/dms3rep/multi/opt/5767906449162442/6767906449166328/80ba84941eca90379882caa7cf5c97ce-1920w.jpg"
    },
    {
      "id": "custom_18f680e1-c541-40ae-8d02-08b0e778441d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019fd923-c9f9-7208-b19a-207e352152fd.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and marble countertops.",
        "public_id": "019fd923-c9f9-7208-b19a-207e352152fd",
        "storage_key": "property/6767906449166328/019fd923-c9f9-7208-b19a-207e352152fd.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Featured",
      "link": "false",
      "alt_text": "Bright kitchen in an apartment with white cabinets, marble countertops, and stainless steel appliances at Liberty Pointe in Newark, DE.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/898c847a/dms3rep/multi/opt/5767906449162442/6767906449166328/c3532648a1ebd66ef20b8e351f85cdb4-1920w.jpg"
    },
    {
      "id": "custom_4ce63d1d-3e76-4d41-bb22-47f555e758c8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019fd923-d05f-71ff-b25f-641a5ed26b38.webp",
      "image_media": {
        "alt_text": "Bathroom with sink, vanity, mirror, toilet, and shower.",
        "public_id": "019fd923-d05f-71ff-b25f-641a5ed26b38",
        "storage_key": "property/6767906449166328/019fd923-d05f-71ff-b25f-641a5ed26b38.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Bathroom in a modern apartment with sink, medicine cabinet mirror, toilet, and shower at Liberty Pointe in Newark, DE.",
      "link": "false",
      "alt_text": "Bathroom in a modern apartment with sink, medicine cabinet mirror, toilet, and shower at Liberty Pointe in Newark, DE.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/898c847a/dms3rep/multi/opt/5767906449162442/6767906449166328/71cacd537fb6c4206cd263ce1b7d30e5-1920w.webp"
    },
    {
      "id": "custom_fca77b76-88a4-40f4-a399-44b7d4697f57",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019fd923-d1eb-753c-8899-f6f9198fd1b6.webp",
      "image_media": {
        "alt_text": "Dining area with black table and chairs, ceiling fan, and artwork.",
        "public_id": "019fd923-d1eb-753c-8899-f6f9198fd1b6",
        "storage_key": "property/6767906449166328/019fd923-d1eb-753c-8899-f6f9198fd1b6.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Dining area with a black table, four chairs, abstract art, a ceiling fan, and a bookshelf at Liberty Pointe in Newark, DE.",
      "link": "false",
      "alt_text": "Dining area with a black table, four chairs, abstract art, a ceiling fan, and a bookshelf at Liberty Pointe in Newark, DE.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/898c847a/dms3rep/multi/opt/5767906449162442/6767906449166328/8129e161bdda520a00dfdfe2120f2ef5-1920w.jpg"
    },
    {
      "id": "custom_42432be7-ff57-4247-9e6d-1bca21bb18bd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019fd923-d4b3-740b-ab94-8d712b504ef4.webp",
      "image_media": {
        "alt_text": "Living room with a sofa, armchair, coffee table, and TV stand.",
        "public_id": "019fd923-d4b3-740b-ab94-8d712b504ef4",
        "storage_key": "property/6767906449166328/019fd923-d4b3-740b-ab94-8d712b504ef4.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Living room in a beige apartment with sofa, armchair, coffee table, and a wall-mounted TV at Liberty Pointe in Newark, DE.",
      "link": "false",
      "alt_text": "Living room in a beige apartment with sofa, armchair, coffee table, and a wall-mounted TV at Liberty Pointe in Newark, DE.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/898c847a/dms3rep/multi/opt/5767906449162442/6767906449166328/991cc580f504d6d9741b5d73a18687db-1920w.jpg"
    },
    {
      "id": "custom_ef10666f-6764-47f1-8671-381a9ab3c5e2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019fd923-db5e-75d8-8cb7-0ab6f8433aaf.webp",
      "image_media": {
        "alt_text": "Spacious living and dining area with a sofa, dining table, and TV.",
        "public_id": "019fd923-db5e-75d8-8cb7-0ab6f8433aaf",
        "storage_key": "property/6767906449166328/019fd923-db5e-75d8-8cb7-0ab6f8433aaf.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Open living area in an apartment with beige walls, gray sofa, dining table, and wall TV at Liberty Pointe in Newark, DE.",
      "link": "false",
      "alt_text": "Open living area in an apartment with beige walls, gray sofa, dining table, and wall TV at Liberty Pointe in Newark, DE.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/898c847a/dms3rep/multi/opt/5767906449162442/6767906449166328/42c948058aef51ce548b4aee62608d07-1920w.jpg"
    },
    {
      "id": "custom_5a030e16-676b-410b-8dd1-5bc31e6bcf5d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019fd923-dbc2-7686-a093-cb3e03fdfc63.webp",
      "image_media": {
        "alt_text": "Bedroom with a large bed, dresser, and decor.",
        "public_id": "019fd923-dbc2-7686-a093-cb3e03fdfc63",
        "storage_key": "property/6767906449166328/019fd923-dbc2-7686-a093-cb3e03fdfc63.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Neutral-toned bedroom in an apartment with a bed, dresser, and window blinds at Liberty Pointe in Newark, DE.",
      "link": "false",
      "alt_text": "Neutral-toned bedroom in an apartment with a bed, dresser, and window blinds at Liberty Pointe in Newark, DE.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/898c847a/dms3rep/multi/opt/5767906449162442/6767906449166328/8cbd69ed9f26bb76c57bc5729f599aa2-1920w.jpg"
    },
    {
      "id": "custom_7eb7d114-2471-4730-8a3a-465f4bb9cb3a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019fd923-dccd-705b-a837-b22c009c6278.webp",
      "image_media": {
        "alt_text": "Bedroom with a bed, dresser, and closet.",
        "public_id": "019fd923-dccd-705b-a837-b22c009c6278",
        "storage_key": "property/6767906449166328/019fd923-dccd-705b-a837-b22c009c6278.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Neutral-toned bedroom with bed, dresser, shelf, and window at Liberty Pointe in Newark, DE.",
      "link": "false",
      "alt_text": "Neutral-toned bedroom with bed, dresser, shelf, and window at Liberty Pointe in Newark, DE.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/898c847a/dms3rep/multi/opt/5767906449162442/6767906449166328/773b4838472316f6dc20c6b2ad3d71c2-1920w.jpg"
    },
    {
      "id": "custom_1f356c0d-cbd9-449c-aae9-e158fdc68a59",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019fd923-dfe4-73de-b564-63303b1ae55b.webp",
      "image_media": {
        "alt_text": "Staged bedroom with a queen-size bed, dresser, and television.",
        "public_id": "019fd923-dfe4-73de-b564-63303b1ae55b",
        "storage_key": "property/6767906449166328/019fd923-dfe4-73de-b564-63303b1ae55b.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Bedroom with a large bed, dresser, wall-mounted TV, and a potted plant by a window at Liberty Pointe in Newark, DE.",
      "link": "false",
      "alt_text": "Bedroom with a large bed, dresser, wall-mounted TV, and a potted plant by a window at Liberty Pointe in Newark, DE.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/898c847a/dms3rep/multi/opt/5767906449162442/6767906449166328/ff01c61377b5792c76236a09aaf82c53-1920w.jpg"
    },
    {
      "id": "custom_2c64483d-71f4-42aa-abf1-3b66ea9a54f0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019fd923-e734-75ee-8095-dd5253189418.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, elliptical, and stationary bike.",
        "public_id": "019fd923-e734-75ee-8095-dd5253189418",
        "storage_key": "property/6767906449166328/019fd923-e734-75ee-8095-dd5253189418.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Featured",
      "link": "false",
      "alt_text": "Indoor gym in a residential community with treadmills, elliptical, and a stationary bike at Liberty Pointe in Newark, DE.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/898c847a/dms3rep/multi/opt/5767906449162442/6767906449166328/950c94f101780ec31acec9f8f97add99-1920w.jpg"
    },
    {
      "id": "custom_61cad86c-4c9a-4c59-ab73-4e252896b700",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019fd923-e7a1-720a-aff6-c5efcf7cc973.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills and weight machines.",
        "public_id": "019fd923-e7a1-720a-aff6-c5efcf7cc973",
        "storage_key": "property/6767906449166328/019fd923-e7a1-720a-aff6-c5efcf7cc973.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Compact community gym with two treadmills and a weight bench at Liberty Pointe in Newark, DE.",
      "link": "false",
      "alt_text": "Compact community gym with two treadmills and a weight bench at Liberty Pointe in Newark, DE.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/898c847a/dms3rep/multi/opt/5767906449162442/6767906449166328/44e532926c1248ac3b9d50a4401dfbdc-1920w.webp"
    },
    {
      "id": "custom_b21aa8ca-7cf3-40a5-91a7-72b26554f066",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019fd923-e962-732e-880b-74f2716738a1.webp",
      "image_media": {
        "alt_text": "Gym with elliptical, stationary bikes, and weight bench.",
        "public_id": "019fd923-e962-732e-880b-74f2716738a1",
        "storage_key": "property/6767906449166328/019fd923-e962-732e-880b-74f2716738a1.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Indoor fitness center with cardio machines and a mirrored wall at Liberty Pointe in Newark, DE.",
      "link": "false",
      "alt_text": "Indoor fitness center with cardio machines and a mirrored wall at Liberty Pointe in Newark, DE.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/898c847a/dms3rep/multi/opt/5767906449162442/6767906449166328/16a0fc94fe4e8ecf27eb33e89d0c47fa-1920w.webp"
    },
    {
      "id": "custom_64b95419-d4d6-478f-963c-4fad234acfee",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019fd923-f01a-70c1-95fc-be502d3e7174.webp",
      "image_media": {
        "alt_text": "Playground and dog park with apartment buildings in the background.",
        "public_id": "019fd923-f01a-70c1-95fc-be502d3e7174",
        "storage_key": "property/6767906449166328/019fd923-f01a-70c1-95fc-be502d3e7174.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Open green lawn with a fenced dog park and playground and swings, surrounded by brick apartment buildings at Liberty Pointe in Newark, DE.",
      "link": "false",
      "alt_text": "Open green lawn with a playground and swings, surrounded by brick apartment buildings at Liberty Pointe in Newark, DE.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/898c847a/dms3rep/multi/opt/5767906449162442/6767906449166328/f79a1f352568e01809988b0e87745dd8-1920w.webp"
    },
    {
      "id": "custom_48bb5afc-355d-4ef2-96d4-044916b2d418",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019fd923-f259-72cf-bb67-69135a9b7253.webp",
      "image_media": {
        "alt_text": "Outdoor picnic tables and grills in a grassy courtyard with apartment buildings in the background.",
        "public_id": "019fd923-f259-72cf-bb67-69135a9b7253",
        "storage_key": "property/6767906449166328/019fd923-f259-72cf-bb67-69135a9b7253.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Community",
      "description": "Outdoor communal grilling area with two metal picnic tables, a grill, and a nearby apartment building at Liberty Pointe in Newark, DE.",
      "link": "false",
      "alt_text": "Outdoor communal grilling area with two metal picnic tables, a grill, and a nearby apartment building at Liberty Pointe in Newark, DE.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/898c847a/dms3rep/multi/opt/5767906449162442/6767906449166328/ca23a4913a8d520f8f9b2f143e672be2-1920w.jpg"
    },
    {
      "id": "custom_b66f6930-ce71-45ae-8ffa-cb50b1df9b0f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019fd923-f201-77dd-a6d1-3c93830ab90b.webp",
      "image_media": {
        "alt_text": "Playground with swings, slide, and picnic tables with grills.",
        "public_id": "019fd923-f201-77dd-a6d1-3c93830ab90b",
        "storage_key": "property/6767906449166328/019fd923-f201-77dd-a6d1-3c93830ab90b.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Community",
      "description": "Featured",
      "link": "false",
      "alt_text": "Outdoor community playground with orange slide, blue swings, and picnic tables at Liberty Pointe in Newark, DE.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/898c847a/dms3rep/multi/opt/5767906449162442/6767906449166328/21f946a63ca39804b3c57385e75183d6-1920w.jpg"
    },
    {
      "id": "custom_fdd5b0d9-3ada-498c-b38e-a949c09c492c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019fd923-f59e-709e-9082-6dc0d1cd641b.webp",
      "image_media": {
        "alt_text": "Exterior of a brick apartment building with a parking lot in front and blue sky above.",
        "public_id": "019fd923-f59e-709e-9082-6dc0d1cd641b",
        "storage_key": "property/6767906449166328/019fd923-f59e-709e-9082-6dc0d1cd641b.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Exterior view of a brick apartment building with a parking lot and landscaping at Liberty Pointe in Newark, DE.",
      "link": "false",
      "alt_text": "Exterior view of a brick apartment building with a parking lot and landscaping at Liberty Pointe in Newark, DE.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/898c847a/dms3rep/multi/opt/b17060122cf0bc1dfb913a7e19a2f858-75979377-1920w.webp"
    },
    {
      "id": "custom_98300200-b508-41d4-b03f-ae1378283308",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019fd923-fe27-7519-a466-ed335291f01b.webp",
      "image_media": {
        "alt_text": "Exterior view of community building with picnic tables and grills, and apartment buildings in the background.",
        "public_id": "019fd923-fe27-7519-a466-ed335291f01b",
        "storage_key": "property/6767906449166328/019fd923-fe27-7519-a466-ed335291f01b.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Community",
      "description": "Single-story clubhouse with glass entry doors, concrete patio, and a nearby playground in a green apartment complex at Liberty Pointe in Newark, DE.",
      "link": "false",
      "alt_text": "Single-story clubhouse with glass entry doors, concrete patio, and a nearby playground in a green apartment complex at Liberty Pointe in Newark, DE.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/898c847a/dms3rep/multi/opt/5767906449162442/6767906449166328/3d076f671d9c417a75fa2d7af384b6e5-1920w.jpg"
    },
    {
      "id": "custom_559a3c10-d074-490a-8312-fc7e4ef943ff",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019fd923-fe3f-769f-a0d7-c4c142d59c1d.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings and grounds, featuring a playground.",
        "public_id": "019fd923-fe3f-769f-a0d7-c4c142d59c1d",
        "storage_key": "property/6767906449166328/019fd923-fe3f-769f-a0d7-c4c142d59c1d.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Community",
      "description": "Aerial view of a multifamily community with brick buildings, a large green lawn, playground, trees, and parking at Liberty Pointe in Newark, DE.",
      "link": "false",
      "alt_text": "Aerial view of a multifamily community with brick buildings, a large green lawn, playground, trees, and parking at Liberty Pointe in Newark, DE.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/898c847a/dms3rep/multi/opt/5767906449162442/6767906449166328/4f62bf7ec3521915d4e44e4de95144b3-1920w.jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_099a7623-0dbf-4ba3-85e6-49de7f250b37",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "poi_name": "P.F. Chang's",
      "poi_type": "Restaurants",
      "poi_address": "331 Christiana Mall, Newark, DE 19702, USA",
      "poi_short_description": "Family-friendly chain offering creative takes on Asian fare in a striking space.",
      "poi_long_description": "Family-friendly chain offering creative takes on Asian fare in a striking space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-37c0-751a-8176-9535ab390c82.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-37c0-751a-8176-9535ab390c82",
        "storage_key": "property/6767906449166328/019d0268-37c0-751a-8176-9535ab390c82.webp",
        "width": 1280,
        "height": 635
      },
      "poi_business_url": "https://locations.pfchangs.com/de/newark/331-christiana-mall.html?utm_source=google_gbp&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=9150130208081780931&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pf-changs",
      "poi_latitude": "39.6787314",
      "poi_longitude": "-75.6531201",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 302-444-0324",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-b3f0-717e-935c-7abe3313fd5a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-b3f0-717e-935c-7abe3313fd5a",
        "storage_key": "property/6767906449166328/019d0268-b3f0-717e-935c-7abe3313fd5a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6VGzcJwBx4kRwyBJ3fHK-34",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chinese_restaurant"
    },
    {
      "id": "custom_6a804acf-d50b-475d-a355-6ddd72f8ef05",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "poi_name": "The Cheesecake Factory",
      "poi_type": "Restaurants",
      "poi_address": "350 Christiana Mall, Newark, DE 19702, USA",
      "poi_short_description": "American chain restaurant offering sizable portions from a vast menu including signature cheesecake",
      "poi_long_description": "American chain restaurant offering sizable portions from a vast menu including signature cheesecake",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-369b-706f-bdf0-1b344348fead.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-369b-706f-bdf0-1b344348fead",
        "storage_key": "property/6767906449166328/019d0268-369b-706f-bdf0-1b344348fead.webp",
        "width": 1280,
        "height": 764
      },
      "poi_business_url": "https://locations.thecheesecakefactory.com/de/newark-151.html?utm_source=Google&utm_medium=Maps&utm_campaign=Google+Places",
      "poi_directions_map_url": "https://maps.google.com/?cid=11726206093432098982&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-cheesecake-factory",
      "poi_latitude": "39.6787384",
      "poi_longitude": "-75.6510922",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 302-454-9444",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-b3f0-717e-935c-7abe3313fd5a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-b3f0-717e-935c-7abe3313fd5a",
        "storage_key": "property/6767906449166328/019d0268-b3f0-717e-935c-7abe3313fd5a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ____jz0Bx4kRppAKWlDau6I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_8d6e8e91-1237-460c-9b33-e3fbf66e45b5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "poi_name": "CAVA",
      "poi_type": "Restaurants",
      "poi_address": "2150 Fashion Center Blvd, Newark, DE 19702, USA",
      "poi_short_description": "Mediterranean restaurant for thoughtful food with customizable greens & grains bowls, pitas & salad.",
      "poi_long_description": "Mediterranean restaurant for thoughtful food with customizable greens & grains bowls, pitas & salad.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-37cc-723e-a319-8bddd75e45e0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-37cc-723e-a319-8bddd75e45e0",
        "storage_key": "property/6767906449166328/019d0268-37cc-723e-a319-8bddd75e45e0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://cava.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9306772216593200544&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cava",
      "poi_latitude": "39.6718341",
      "poi_longitude": "-75.64825619999999",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 862-339-7686",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-b3f0-717e-935c-7abe3313fd5a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-b3f0-717e-935c-7abe3313fd5a",
        "storage_key": "property/6767906449166328/019d0268-b3f0-717e-935c-7abe3313fd5a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJh2YN740Bx4kRoDWDhwVMKIE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mediterranean_restaurant"
    },
    {
      "id": "custom_c88acf2f-816c-402f-99bf-cb22e5dcf56c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "poi_name": "Shake Shack Christiana",
      "poi_type": "Restaurants",
      "poi_address": "2120 Fashion Center Blvd, Christiana, DE 19702, USA",
      "poi_short_description": "Hip, counter-serve chain for gourmet takes on fast-food classics like burgers & frozen custard.",
      "poi_long_description": "Hip, counter-serve chain for gourmet takes on fast-food classics like burgers & frozen custard.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-37c0-751a-8176-987f15ce2da3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-37c0-751a-8176-987f15ce2da3",
        "storage_key": "property/6767906449166328/019d0268-37c0-751a-8176-987f15ce2da3.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.shakeshack.com/location/christiana-de/?utm_source=google&utm_medium=listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=13661532507683598917&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "shake-shack-christiana",
      "poi_latitude": "39.67243740000001",
      "poi_longitude": "-75.6495194",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 302-597-7417",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-b3f0-717e-935c-7abe3313fd5a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-b3f0-717e-935c-7abe3313fd5a",
        "storage_key": "property/6767906449166328/019d0268-b3f0-717e-935c-7abe3313fd5a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJB57sYDkBx4kRRbLuD2-Dl70",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "custom_1c06edaf-9e7a-4916-8719-ee6200b730a0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "poi_name": "Grain Craft Bar + Kitchen",
      "poi_type": "Restaurants",
      "poi_address": "270 E Main St, Newark, DE 19711, USA",
      "poi_short_description": "Rustic-chic gastropub with USB chargers at the bar offering craft beer, upscale bar eats & music.",
      "poi_long_description": "Rustic-chic gastropub with USB chargers at the bar offering craft beer, upscale bar eats & music.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-3c5a-76dc-bb57-7e8cbcd96817.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-3c5a-76dc-bb57-7e8cbcd96817",
        "storage_key": "property/6767906449166328/019d0268-3c5a-76dc-bb57-7e8cbcd96817.webp",
        "width": 950,
        "height": 633
      },
      "poi_business_url": "http://www.meetatgrain.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1483700492798230401&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "grain-craft-bar--kitchen",
      "poi_latitude": "39.684055",
      "poi_longitude": "-75.742228",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 302-444-8646",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-b3ec-727c-840b-8c42b19d1785.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-b3ec-727c-840b-8c42b19d1785",
        "storage_key": "property/6767906449166328/019d0268-b3ec-727c-840b-8c42b19d1785.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJNbxjDTyqx4kRgX9PurwplxQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar"
    },
    {
      "id": "custom_734424e0-f223-41fb-b791-22822ffc586a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "poi_name": "Roots Natural Kitchen",
      "poi_type": "Restaurants",
      "poi_address": "129 E Main St, Newark, DE 19711, USA",
      "poi_short_description": "Modern, colorful counter-serve eatery offering custom & signature grain bowls & salads.",
      "poi_long_description": "Modern, colorful counter-serve eatery offering custom & signature grain bowls & salads.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-3d72-72b9-9988-7497bc2526ed.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-3d72-72b9-9988-7497bc2526ed",
        "storage_key": "property/6767906449166328/019d0268-3d72-72b9-9988-7497bc2526ed.webp",
        "width": 964,
        "height": 1280
      },
      "poi_business_url": "http://www.rootsnaturalkitchen.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16469656714878260460&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "roots-natural-kitchen",
      "poi_latitude": "39.6832735",
      "poi_longitude": "-75.7479807",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 302-273-2620",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-b3f0-717e-935c-7abe3313fd5a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-b3f0-717e-935c-7abe3313fd5a",
        "storage_key": "property/6767906449166328/019d0268-b3f0-717e-935c-7abe3313fd5a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7y_ziDqqx4kR7BTyroX5j-Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_05434857-1923-4e75-b999-97e7ca110900",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "poi_name": "Caffe Gelato Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "90 E Main St near, Newark, DE 19711, USA",
      "poi_short_description": "Welcoming cafe features gourmet Italian-American fare, a robust wine list, desserts & patio seating.",
      "poi_long_description": "Welcoming cafe features gourmet Italian-American fare, a robust wine list, desserts & patio seating.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-3d1b-73b0-a327-8da3af677320.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-3d1b-73b0-a327-8da3af677320",
        "storage_key": "property/6767906449166328/019d0268-3d1b-73b0-a327-8da3af677320.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.caffegelato.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16606850448866005077&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "caffe-gelato-restaurant",
      "poi_latitude": "39.6834086",
      "poi_longitude": "-75.7499079",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 302-738-5811",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-b3f0-717e-935c-7abe3313fd5a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-b3f0-717e-935c-7abe3313fd5a",
        "storage_key": "property/6767906449166328/019d0268-b3f0-717e-935c-7abe3313fd5a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJXQtwijCqx4kRVdCxEn9id-Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_840a73a0-4d23-49b3-841f-dfb2b6bac27f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "poi_name": "Deer Park Tavern",
      "poi_type": "Restaurants",
      "poi_address": "108 W Main St, Newark, DE 19711, USA",
      "poi_short_description": "Landmark spot on site with Revolutionary War roots features a bar, American fare & trivia nights.",
      "poi_long_description": "Landmark spot on site with Revolutionary War roots features a bar, American fare & trivia nights.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-3e48-724a-a793-0a03270bd8eb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-3e48-724a-a793-0a03270bd8eb",
        "storage_key": "property/6767906449166328/019d0268-3e48-724a-a793-0a03270bd8eb.webp",
        "width": 1280,
        "height": 676
      },
      "poi_business_url": "https://www.deerparktavern.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6811427277290188770&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "deer-park-tavern",
      "poi_latitude": "39.6832238",
      "poi_longitude": "-75.7559908",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 302-369-9414",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-b3f0-717e-935c-7abe3313fd5a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-b3f0-717e-935c-7abe3313fd5a",
        "storage_key": "property/6767906449166328/019d0268-b3f0-717e-935c-7abe3313fd5a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJRQE_gTCqx4kR4q9JLAUNh14",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_6cabaa16-dead-45e6-878a-64b7f4bc293e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "poi_name": "Klondike Kate's Restaurant & Saloon",
      "poi_type": "Restaurants",
      "poi_address": "158 E Main St, Newark, DE 19711, USA",
      "poi_short_description": "Classic American fare & drinks in a circa-1880 building featuring vintage railroad station decor.",
      "poi_long_description": "Classic American fare & drinks in a circa-1880 building featuring vintage railroad station decor.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-4272-73ff-aba5-f1ebaf823969.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-4272-73ff-aba5-f1ebaf823969",
        "storage_key": "property/6767906449166328/019d0268-4272-73ff-aba5-f1ebaf823969.webp",
        "width": 980,
        "height": 653
      },
      "poi_business_url": "https://www.klondikekates.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10068181487235063260&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "klondike-kates-restaurant--saloon",
      "poi_latitude": "39.6837323",
      "poi_longitude": "-75.7469155",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 302-737-6100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-b3f0-717e-935c-7abe3313fd5a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-b3f0-717e-935c-7abe3313fd5a",
        "storage_key": "property/6767906449166328/019d0268-b3f0-717e-935c-7abe3313fd5a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJEb_2Wzqqx4kR3F3PGLhduYs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_9635100e-91ce-4a9c-a11a-f62095fcd85b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "poi_name": "McGlynns Pub - Glasgow",
      "poi_type": "Restaurants",
      "poi_address": "108 Peoples Plaza, Newark, DE 19702, USA",
      "poi_short_description": "Irish-influenced alehouse serving burgers, wings, nachos & salads with a big beer selection.",
      "poi_long_description": "Irish-influenced alehouse serving burgers, wings, nachos & salads with a big beer selection.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-4310-726a-b2a1-8bada2adf818.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-4310-726a-b2a1-8bada2adf818",
        "storage_key": "property/6767906449166328/019d0268-4310-726a-b2a1-8bada2adf818.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.mcglynnspub.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17489796336130561757&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mcglynns-pub---glasgow",
      "poi_latitude": "39.601043",
      "poi_longitude": "-75.746269",
      "poi_miles_from_property": "9.8",
      "poi_walking_minutes": "3 hours 36 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 302-834-6661",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-b3ec-727c-840b-8c42b19d1785.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-b3ec-727c-840b-8c42b19d1785",
        "storage_key": "property/6767906449166328/019d0268-b3ec-727c-840b-8c42b19d1785.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ04H6yW-ox4kR3Zb9UBo9uPI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pub"
    },
    {
      "id": "custom_cf18e0a2-251e-4d7a-b517-a77883a75a34",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "poi_name": "UDairy Creamery",
      "poi_type": "Restaurants",
      "poi_address": "535 S College Ave, Newark, DE 19716, USA",
      "poi_short_description": "Shop selling premium ice cream produced by University of Delaware agriculture students.",
      "poi_long_description": "Shop selling premium ice cream produced by University of Delaware agriculture students.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-4310-726a-b2a1-8f97fc5f49ab.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-4310-726a-b2a1-8f97fc5f49ab",
        "storage_key": "property/6767906449166328/019d0268-4310-726a-b2a1-8f97fc5f49ab.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.udel.edu/academics/colleges/canr/about/facilities-labs/udairy-creamery/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2333097266923151161&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "udairy-creamery",
      "poi_latitude": "39.665011",
      "poi_longitude": "-75.7508643",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 7 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 302-831-2486",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-b3f0-717e-935c-7abe3313fd5a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-b3f0-717e-935c-7abe3313fd5a",
        "storage_key": "property/6767906449166328/019d0268-b3f0-717e-935c-7abe3313fd5a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJZZ3px4Wpx4kROZ9jXZrTYCA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "ice_cream_shop"
    },
    {
      "id": "custom_70d98647-9e2a-4a6e-b25b-17922dabd17b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "poi_name": "Ruby Thai Kitchen",
      "poi_type": "Restaurants",
      "poi_address": "132 Christiana Mall, Newark, DE 19702, USA",
      "poi_short_description": "Casual chain outlet serving Thai dishes such as pad thai and bang bang chicken in a mall food court.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-4444-7419-9283-77640a78d8cd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-4444-7419-9283-77640a78d8cd",
        "storage_key": "property/6767906449166328/019d0268-4444-7419-9283-77640a78d8cd.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://ruby-thai-kitchen.keeq.io/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1447952299777130683&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ruby-thai-kitchen",
      "poi_latitude": "39.6787666",
      "poi_longitude": "-75.6520262",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 302-737-1444",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-b3f0-717e-935c-7abe3313fd5a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-b3f0-717e-935c-7abe3313fd5a",
        "storage_key": "property/6767906449166328/019d0268-b3f0-717e-935c-7abe3313fd5a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJNZytiD0Bx4kRuwDt7_EoGBQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "thai_restaurant"
    },
    {
      "id": "custom_8ff96942-9789-44a8-a7bb-f40018a339c7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "poi_name": "Ted's Montana Grill",
      "poi_type": "Restaurants",
      "poi_address": "3194 Fashion Center Blvd, Newark, DE 19702, USA",
      "poi_short_description": "Old West-style steakhouse chain known for its burgers & chops made from bison.",
      "poi_long_description": "Old West-style steakhouse chain known for its burgers & chops made from bison.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-4869-76dd-b308-47f07831db5e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-4869-76dd-b308-47f07831db5e",
        "storage_key": "property/6767906449166328/019d0268-4869-76dd-b308-47f07831db5e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.tedsmontanagrill.com/tmg067.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=7750792800299997892&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "teds-montana-grill",
      "poi_latitude": "39.6713722",
      "poi_longitude": "-75.6516317",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 302-366-1601",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-b3f0-717e-935c-7abe3313fd5a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-b3f0-717e-935c-7abe3313fd5a",
        "storage_key": "property/6767906449166328/019d0268-b3f0-717e-935c-7abe3313fd5a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJO5UB0TsBx4kRxFqJhfxYkGs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_ad50b390-45e4-4c68-b26b-dfe30fcbb73d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "poi_name": "ACME Markets",
      "poi_type": "Shopping & Retail",
      "poi_address": "1 University Dr, Newark, DE 19702, USA",
      "poi_short_description": "Chain grocery store offering produce, a deli, and a bakery, plus pickup and delivery services.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-49a5-743b-b568-ea69c68eed13.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-49a5-743b-b568-ea69c68eed13",
        "storage_key": "property/6767906449166328/019d0268-49a5-743b-b568-ea69c68eed13.webp",
        "width": 496,
        "height": 279
      },
      "poi_business_url": "https://local.acmemarkets.com/de/newark/1-university-plaza.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=3812378242646733016&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "acme-markets",
      "poi_latitude": "39.6669206",
      "poi_longitude": "-75.6719291",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "4 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 302-738-9509",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-b3f0-717e-935c-7d06b28ccaba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-b3f0-717e-935c-7d06b28ccaba",
        "storage_key": "property/6767906449166328/019d0268-b3f0-717e-935c-7d06b28ccaba.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJcZ4UY9YAx4kR2PBiFtBJ6DQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_102c7a69-ef25-4119-a2e6-bb732eff8b5c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "poi_name": "Wawa",
      "poi_type": "Shopping & Retail",
      "poi_address": "970 Christiana Rd, Newark, DE 19702, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-49aa-70ce-ada1-79ff54a0a81b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-49aa-70ce-ada1-79ff54a0a81b",
        "storage_key": "property/6767906449166328/019d0268-49aa-70ce-ada1-79ff54a0a81b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.wawa.com/locations/0873?utm_source=gmblisting&utm_medium=organic&utm_campaign=locallisting",
      "poi_directions_map_url": "https://maps.google.com/?cid=3689829633255175773&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wawa",
      "poi_latitude": "39.6653691",
      "poi_longitude": "-75.6673038",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 302-722-8226",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-b3f0-717e-935c-7abe3313fd5a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-b3f0-717e-935c-7abe3313fd5a",
        "storage_key": "property/6767906449166328/019d0268-b3f0-717e-935c-7abe3313fd5a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4X6HuhcBx4kRXXbie4DoNDM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_c28c39ab-bd99-424a-be4b-1848f8c7b956",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "poi_name": "ALDI",
      "poi_type": "Shopping & Retail",
      "poi_address": "323 W Main St, Christiana, DE 19702, USA",
      "poi_short_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_long_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-4b17-71fb-a7cc-b098ea390b7e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-4b17-71fb-a7cc-b098ea390b7e",
        "storage_key": "property/6767906449166328/019d0268-4b17-71fb-a7cc-b098ea390b7e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://stores.aldi.us/de/christiana/323-w-main-st?utm_source=google&utm_medium=local&utm_campaign=brand&utm_content=storepage_webclick",
      "poi_directions_map_url": "https://maps.google.com/?cid=10700398253457838719&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aldi",
      "poi_latitude": "39.6695414",
      "poi_longitude": "-75.66576470000001",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 855-955-2534",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-b3f0-717e-935c-7d06b28ccaba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-b3f0-717e-935c-7d06b28ccaba",
        "storage_key": "property/6767906449166328/019d0268-b3f0-717e-935c-7d06b28ccaba.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJzz7aXWQBx4kRf5KQtIRzf5Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_64612203-f30c-4bb6-b8f4-e247acb572e8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "poi_name": "Trader Joe's",
      "poi_type": "Shopping & Retail",
      "poi_address": "2500 Fashion Center Blvd, Newark, DE 19702, USA",
      "poi_short_description": "Grocery chain with a variety of signature items, plus produce, dairy & more (most sell wine & beer).",
      "poi_long_description": "Grocery chain with a variety of signature items, plus produce, dairy & more (most sell wine & beer).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-4e89-70bf-949f-e1d61a9c852a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-4e89-70bf-949f-e1d61a9c852a",
        "storage_key": "property/6767906449166328/019d0268-4e89-70bf-949f-e1d61a9c852a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.traderjoes.com/de/newark/759/?utm_source=gmb&utm_medium=organic&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=13903272674461544209&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "trader-joes",
      "poi_latitude": "39.6731366",
      "poi_longitude": "-75.64803839999999",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 302-292-6825",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-b3f0-717e-935c-7d06b28ccaba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-b3f0-717e-935c-7d06b28ccaba",
        "storage_key": "property/6767906449166328/019d0268-b3f0-717e-935c-7d06b28ccaba.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5aagUD0Bx4kREe-ssNVY8sA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_169a64ee-1935-49dc-b00e-9888e180fe5d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "poi_name": "Costco Wholesale",
      "poi_type": "Shopping & Retail",
      "poi_address": "900 Center Blvd S, Newark, DE 19702, USA",
      "poi_short_description": "Members-only warehouse selling a huge variety of items including bulk groceries, electronics & more.",
      "poi_long_description": "Members-only warehouse selling a huge variety of items including bulk groceries, electronics & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-5011-77fa-b3f1-8e64e0556d43.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-5011-77fa-b3f1-8e64e0556d43",
        "storage_key": "property/6767906449166328/019d0268-5011-77fa-b3f1-8e64e0556d43.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.costco.com/warehouse-locations/newark-DE-246.html?utm_term=KW&utm_campaign=Homepage&utm_medium=GMB&utm_source=Google&utm_content=Link",
      "poi_directions_map_url": "https://maps.google.com/?cid=2782086882383962843&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "costco-wholesale",
      "poi_latitude": "39.6770965",
      "poi_longitude": "-75.64740479999999",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 302-894-0511",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-b3ed-719f-b952-9066907c9688.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-b3ed-719f-b952-9066907c9688",
        "storage_key": "property/6767906449166328/019d0268-b3ed-719f-b952-9066907c9688.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJcy6GMT4Bx4kR2yLFhkf1myY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "warehouse_store"
    },
    {
      "id": "custom_c31c20df-3324-4c72-b560-7f2518b03c19",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Shopping & Retail",
      "poi_address": "800 Christiana Mall, Newark, DE 19702, USA",
      "poi_short_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_long_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-500f-707b-bff1-aebe2441fb7b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-500f-707b-bff1-aebe2441fb7b",
        "storage_key": "property/6767906449166328/019d0268-500f-707b-bff1-aebe2441fb7b.webp",
        "width": 720,
        "height": 480
      },
      "poi_business_url": "https://www.cvs.com/store-locator/newark-de-pharmacies/800-christiana-mall-newark-de-19702/storeid=17621?WT.mc_id=LS_GOOGLE_RX_17621",
      "poi_directions_map_url": "https://maps.google.com/?cid=10503530488828889127&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "39.6783502",
      "poi_longitude": "-75.6497691",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 302-669-4010",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-b809-7065-abe9-c1bbd1b45ad8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-b809-7065-abe9-c1bbd1b45ad8",
        "storage_key": "property/6767906449166328/019d0268-b809-7065-abe9-c1bbd1b45ad8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJFRln_T0Bx4kRJ4ghWlQJxJE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_a4990fad-3a9e-4e07-b671-0309c48b8d77",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "800 Christiana Mall, Newark, DE 19702, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-5134-71a5-bf7c-4e7be487caaa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-5134-71a5-bf7c-4e7be487caaa",
        "storage_key": "property/6767906449166328/019d0268-5134-71a5-bf7c-4e7be487caaa.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.target.com/sl/christiana/2764",
      "poi_directions_map_url": "https://maps.google.com/?cid=13032935909277248621&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "target",
      "poi_latitude": "39.6789231",
      "poi_longitude": "-75.64941499999999",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 302-669-4009",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-b3ed-719f-b952-9066907c9688.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-b3ed-719f-b952-9066907c9688",
        "storage_key": "property/6767906449166328/019d0268-b3ed-719f-b952-9066907c9688.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJFRln_T0Bx4kRbSzndChK3rQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_12d26436-3893-4d7a-96a6-c22001271ab4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "poi_name": "Best Buy",
      "poi_type": "Shopping & Retail",
      "poi_address": "2700 Fashion Center Blvd, Newark, DE 19702, USA",
      "poi_short_description": "Chain retailer with a large array of brand-name electronics, computers, appliances & more.",
      "poi_long_description": "Chain retailer with a large array of brand-name electronics, computers, appliances & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-5506-707a-9ade-4dfefe30aef4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-5506-707a-9ade-4dfefe30aef4",
        "storage_key": "property/6767906449166328/019d0268-5506-707a-9ade-4dfefe30aef4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://stores.bestbuy.com/de/newark/2700-fashion-center-blvd-1480.html/?ref=NS&loc=ns100",
      "poi_directions_map_url": "https://maps.google.com/?cid=3227089769131828530&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "best-buy",
      "poi_latitude": "39.6724492",
      "poi_longitude": "-75.64710989999999",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 302-369-7015",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-b3ed-719f-b952-9066907c9688.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-b3ed-719f-b952-9066907c9688",
        "storage_key": "property/6767906449166328/019d0268-b3ed-719f-b952-9066907c9688.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJaZAxVwMBx4kRMmVmEwztyCw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "electronics_store"
    },
    {
      "id": "custom_d03a1317-7cc2-49d2-812c-1cc05b1b357a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "poi_name": "Burlington",
      "poi_type": "Shopping & Retail",
      "poi_address": "55 University Dr, Newark, DE 19702, USA",
      "poi_short_description": "Retailer for brand-name apparel for men, women, and children, plus shoes and home decor.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-570a-716d-aaa3-b6478c7985f6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-570a-716d-aaa3-b6478c7985f6",
        "storage_key": "property/6767906449166328/019d0268-570a-716d-aaa3-b6478c7985f6.webp",
        "width": 488,
        "height": 289
      },
      "poi_business_url": "https://stores.burlington.com/de/newark/272/?utm_source=google&utm_medium=organic&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=8767854553885439159&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "burlington",
      "poi_latitude": "39.6664757",
      "poi_longitude": "-75.67038889999999",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 302-369-8201",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-b3ed-719f-b952-9066907c9688.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-b3ed-719f-b952-9066907c9688",
        "storage_key": "property/6767906449166328/019d0268-b3ed-719f-b952-9066907c9688.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJpfONdtYAx4kRt_ShPkOtrXk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "clothing_store"
    },
    {
      "id": "custom_47316f37-234c-4934-926f-dd19a090fc47",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "poi_name": "Apple Christiana Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "125 Christiana Mall, Newark, DE 19702, USA",
      "poi_short_description": "Apple retail store selling iPhones, iPads & more in sleekly designed spaces.",
      "poi_long_description": "Apple retail store selling iPhones, iPads & more in sleekly designed spaces.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-57a6-754d-bcea-9b9755969806.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-57a6-754d-bcea-9b9755969806",
        "storage_key": "property/6767906449166328/019d0268-57a6-754d-bcea-9b9755969806.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.apple.com/retail/christianamall?cid=aos-us-seo-maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=2670333949121167859&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "apple-christiana-mall",
      "poi_latitude": "39.679285",
      "poi_longitude": "-75.653025",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 302-533-3514",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-b3ed-719f-b952-9066907c9688.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-b3ed-719f-b952-9066907c9688",
        "storage_key": "property/6767906449166328/019d0268-b3ed-719f-b952-9066907c9688.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJR9exkT0Bx4kR84EIJZTuDiU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "electronics_store"
    },
    {
      "id": "custom_0db67b9f-7802-426a-a59c-cbd8726ac868",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "poi_name": "Thurgood Marshall Elementary School",
      "poi_type": "Education",
      "poi_address": "101 Barrett Run Dr, Newark, DE 19702, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-5877-71f7-ab8e-10803b5f6b07.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-5877-71f7-ab8e-10803b5f6b07",
        "storage_key": "property/6767906449166328/019d0268-5877-71f7-ab8e-10803b5f6b07.webp",
        "width": 800,
        "height": 548
      },
      "poi_business_url": "https://www.christinak12.org/MarshallES",
      "poi_directions_map_url": "https://maps.google.com/?cid=16644534713778014698&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "thurgood-marshall-elementary-school",
      "poi_latitude": "39.6449808",
      "poi_longitude": "-75.68352070000002",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 302-454-4700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-b80e-74cc-b94d-1290689395ca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-b80e-74cc-b94d-1290689395ca",
        "storage_key": "property/6767906449166328/019d0268-b80e-74cc-b94d-1290689395ca.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJQUR8SjwHx4kR6olluiJE_eY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_c3fee92c-1777-4aa1-94fb-93e1a76853f1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "poi_name": "Henry M. Brader Elementary School",
      "poi_type": "Education",
      "poi_address": "350 Four Seasons Pkwy, Newark, DE 19702, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-5b88-75ab-bcf8-f054a323c1a7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-5b88-75ab-bcf8-f054a323c1a7",
        "storage_key": "property/6767906449166328/019d0268-5b88-75ab-bcf8-f054a323c1a7.webp",
        "width": 800,
        "height": 534
      },
      "poi_business_url": "http://www.braderes.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4231313589751538138&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "henry-m-brader-elementary-school",
      "poi_latitude": "39.6256783",
      "poi_longitude": "-75.75362989999999",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 25 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 302-454-5959",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-b80e-74cc-b94d-1290689395ca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-b80e-74cc-b94d-1290689395ca",
        "storage_key": "property/6767906449166328/019d0268-b80e-74cc-b94d-1290689395ca.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ-zpDKVSox4kR2mFsmkqluDo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_398ad90c-681e-450d-b422-ed5972fd0b8f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "poi_name": "May B. Leasure Elementary School",
      "poi_type": "Education",
      "poi_address": "1015 Church Rd, Newark, DE 19702, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-5ce1-7756-b898-fc96756cf992.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-5ce1-7756-b898-fc96756cf992",
        "storage_key": "property/6767906449166328/019d0268-5ce1-7756-b898-fc96756cf992.webp",
        "width": 800,
        "height": 533
      },
      "poi_business_url": "http://www.leasurees.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7460078830146890011&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "may-b-leasure-elementary-school",
      "poi_latitude": "39.6212819",
      "poi_longitude": "-75.680239",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 302-454-2103",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-b80e-74cc-b94d-1290689395ca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-b80e-74cc-b94d-1290689395ca",
        "storage_key": "property/6767906449166328/019d0268-b80e-74cc-b94d-1290689395ca.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ5dy27acHx4kRGylRuyuGh2c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_9d1a4ca2-aef3-4064-a766-8403259b8637",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "poi_name": "William B. Keene Elementary School",
      "poi_type": "Education",
      "poi_address": "200 Cpl. Stephen J Ballard Wy, Newark, DE 19702, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-5e09-776a-b3bf-8939bdbb32c6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-5e09-776a-b3bf-8939bdbb32c6",
        "storage_key": "property/6767906449166328/019d0268-5e09-776a-b3bf-8939bdbb32c6.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.keenees.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4154398955317654868&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "william-b-keene-elementary-school",
      "poi_latitude": "39.6034252",
      "poi_longitude": "-75.7278975",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 45 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 302-454-2018",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-b80e-74cc-b94d-1290689395ca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-b80e-74cc-b94d-1290689395ca",
        "storage_key": "property/6767906449166328/019d0268-b80e-74cc-b94d-1290689395ca.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJafYBYCGox4kRVHX2wtZjpzk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_cc8fdbdb-5c8f-4c97-9a5b-80e3b54c365c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "poi_name": "Shue-Medill Middle School",
      "poi_type": "Education",
      "poi_address": "1500 Capitol Tr, Newark, DE 19711, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-5dfe-71d8-b4b9-c74e829010d4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-5dfe-71d8-b4b9-c74e829010d4",
        "storage_key": "property/6767906449166328/019d0268-5dfe-71d8-b4b9-c74e829010d4.webp",
        "width": 730,
        "height": 410
      },
      "poi_business_url": "https://www.christinak12.org/Page/59",
      "poi_directions_map_url": "https://maps.google.com/?cid=391646026775419506&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "shue-medill-middle-school",
      "poi_latitude": "39.6976563",
      "poi_longitude": "-75.7049206",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 302-454-2171",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-b80e-74cc-b94d-1290689395ca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-b80e-74cc-b94d-1290689395ca",
        "storage_key": "property/6767906449166328/019d0268-b80e-74cc-b94d-1290689395ca.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJFVch5oQAx4kRclqkf_xnbwU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_d175b906-0c2f-408d-879f-4d41fbe26ced",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "poi_name": "Glasgow High School",
      "poi_type": "Education",
      "poi_address": "1901 S College Ave, Newark, DE 19702, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-61c2-77ed-9943-8bc503d56c2e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-61c2-77ed-9943-8bc503d56c2e",
        "storage_key": "property/6767906449166328/019d0268-61c2-77ed-9943-8bc503d56c2e.webp",
        "width": 803,
        "height": 452
      },
      "poi_business_url": "http://www.glasgowhs.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7048128234314181675&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "glasgow-high-school",
      "poi_latitude": "39.630089",
      "poi_longitude": "-75.74169169999999",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 302-631-5600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-b80e-74cc-b94d-1290689395ca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-b80e-74cc-b94d-1290689395ca",
        "storage_key": "property/6767906449166328/019d0268-b80e-74cc-b94d-1290689395ca.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ_zx9zbSpx4kRK6yyWUn7z2E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_507e8233-5478-4548-a50d-1b9d2a223b60",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "poi_name": "Newark Charter Senior High School",
      "poi_type": "Education",
      "poi_address": "200 McIntire Dr, Newark, DE 19711, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.newarkcharterschool.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17754051170133577854&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "newark-charter-senior-high-school",
      "poi_latitude": "39.6530881",
      "poi_longitude": "-75.7877902",
      "poi_miles_from_property": "7.8",
      "poi_walking_minutes": "2 hours 54 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 302-369-2001",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-b80e-74cc-b94d-1290689395ca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-b80e-74cc-b94d-1290689395ca",
        "storage_key": "property/6767906449166328/019d0268-b80e-74cc-b94d-1290689395ca.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJi8uDGj-px4kRfpDrZ3kPY_Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_974104be-2697-4e61-ab03-8cf1a8495d43",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "poi_name": "University of Delaware",
      "poi_type": "Education",
      "poi_address": "210 S College Ave, Newark, DE 19716, USA",
      "poi_short_description": "Public research school dating to 1743 & known for its science & engineering programs.",
      "poi_long_description": "Public research school dating to 1743 & known for its science & engineering programs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-6351-760d-9f6d-bbdd7b35bca6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-6351-760d-9f6d-bbdd7b35bca6",
        "storage_key": "property/6767906449166328/019d0268-6351-760d-9f6d-bbdd7b35bca6.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "https://www.udel.edu/?utm_source=google&utm_medium=business_profile",
      "poi_directions_map_url": "https://maps.google.com/?cid=13848285473888854897&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-of-delaware",
      "poi_latitude": "39.6809151",
      "poi_longitude": "-75.7523313",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 302-831-2792",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-b80e-74cc-b94d-1290689395ca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-b80e-74cc-b94d-1290689395ca",
        "storage_key": "property/6767906449166328/019d0268-b80e-74cc-b94d-1290689395ca.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJpelbVi6qx4kRceNYY0T-LsA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_f3c3118f-a7c6-4e21-9b2c-f71bf4358ee9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "poi_name": "Paxson Lane KinderCare",
      "poi_type": "Education",
      "poi_address": "100 Paxson Dr, Newark, DE 19702, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-649c-72cc-857e-fd2ecb8d9a73.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-649c-72cc-857e-fd2ecb8d9a73",
        "storage_key": "property/6767906449166328/019d0268-649c-72cc-857e-fd2ecb8d9a73.webp",
        "width": 800,
        "height": 500
      },
      "poi_business_url": "https://www.kindercare.com/our-centers/newark/de/301800?utm_campaign=kc-lg&utm_source=yext&utm_medium=pro&utm_keyword=&utm_platform=&utm_matchtype=&utm_adgroupid=&utm_content=gmb&y_source=1_NTA4MTIyLTcxNS1sb2NhdGlvbi53ZWJzaXRl",
      "poi_directions_map_url": "https://maps.google.com/?cid=13360410901920339745&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "paxson-lane-kindercare",
      "poi_latitude": "39.59551450000001",
      "poi_longitude": "-75.7427824",
      "poi_miles_from_property": "9.8",
      "poi_walking_minutes": "3 hours 37 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 302-834-6931",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-b80e-74cc-b94d-1290689395ca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-b80e-74cc-b94d-1290689395ca",
        "storage_key": "property/6767906449166328/019d0268-b80e-74cc-b94d-1290689395ca.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJL1M94XOox4kRIdc3xu22abk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "custom_a67191eb-1914-43d0-8e0f-414a005198f0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "poi_name": "All Aspire Academy",
      "poi_type": "Education",
      "poi_address": "843 Salem Church Rd, Newark, DE 19702, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-6476-7338-8208-92ac1d1b5567.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-6476-7338-8208-92ac1d1b5567",
        "storage_key": "property/6767906449166328/019d0268-6476-7338-8208-92ac1d1b5567.webp",
        "width": 1080,
        "height": 838
      },
      "poi_business_url": "http://allaspirede.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11963621296538697145&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "all-aspire-academy",
      "poi_latitude": "39.6220842",
      "poi_longitude": "-75.69932589999999",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 302-365-5077",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-b80e-74cc-b94d-1290689395ca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-b80e-74cc-b94d-1290689395ca",
        "storage_key": "property/6767906449166328/019d0268-b80e-74cc-b94d-1290689395ca.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJKZh2vynT_iwRub185y5SB6Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_1d64fae0-e73e-45e9-bbd0-dc18f5a3c8d3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "poi_name": "Cinemark Christiana and XD",
      "poi_type": "Entertainment",
      "poi_address": "1200 Christiana Mall, Newark, DE 19702, USA",
      "poi_short_description": "Theater complex with multiple screens, all-stadium seating & self-service ticketing kiosks.",
      "poi_long_description": "Theater complex with multiple screens, all-stadium seating & self-service ticketing kiosks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-687a-7279-bdc1-8ac3f5e25469.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-687a-7279-bdc1-8ac3f5e25469",
        "storage_key": "property/6767906449166328/019d0268-687a-7279-bdc1-8ac3f5e25469.webp",
        "width": 1200,
        "height": 800
      },
      "poi_business_url": "https://www.cinemark.com/theatres/de-newark/cinemark-christiana-and-xd?utm_medium=organic&utm_source=gmb&utm_campaign=local_listing_theater&utm_content=GMB_listing&y_source=1_MTc0OTMwNjctNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=6256890627889792905&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cinemark-christiana-and-xd",
      "poi_latitude": "39.6811936",
      "poi_longitude": "-75.6502897",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 302-737-2602",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-b808-7372-82e8-12987610180a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-b808-7372-82e8-12987610180a",
        "storage_key": "property/6767906449166328/019d0268-b808-7372-82e8-12987610180a.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJX6mt7zwBx4kRiYfXKeDw1FY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_10d9263f-201c-4228-924a-883f5a1d7be1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "poi_name": "Regal Peoples Plaza",
      "poi_type": "Entertainment",
      "poi_address": "1100 Peoples Plaza, Newark, DE 19702, USA",
      "poi_short_description": "Theater complex with multiple screens featuring new release films, plush seating & concession stand.",
      "poi_long_description": "Theater complex with multiple screens featuring new release films, plush seating & concession stand.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-6a3f-70fa-bda2-b5694431a7eb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-6a3f-70fa-bda2-b5694431a7eb",
        "storage_key": "property/6767906449166328/019d0268-6a3f-70fa-bda2-b5694431a7eb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.regmovies.com/theatres/regal-peoples-plaza-0133?utm_source=google&utm_medium=organic&utm_campaign=gmb-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=14133196401479979375&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "regal-peoples-plaza",
      "poi_latitude": "39.60282",
      "poi_longitude": "-75.74852",
      "poi_miles_from_property": "9.5",
      "poi_walking_minutes": "3 hours 31 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 844-462-7342",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-b808-7372-82e8-12987610180a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-b808-7372-82e8-12987610180a",
        "storage_key": "property/6767906449166328/019d0268-b808-7372-82e8-12987610180a.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJNWf7I2-ox4kRbxELCz8zI8Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_41b1424f-923d-49f2-b716-8dcbec36b2ec",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "poi_name": "Main Street Movies 5",
      "poi_type": "Entertainment",
      "poi_address": "230 E Main St, Newark, DE 19711, USA",
      "poi_short_description": "Contemporary multi-screen movie theater with reclining seats, a snack kiosk & small bar.",
      "poi_long_description": "Contemporary multi-screen movie theater with reclining seats, a snack kiosk & small bar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-698b-76bd-82ef-841657c3f805.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-698b-76bd-82ef-841657c3f805",
        "storage_key": "property/6767906449166328/019d0268-698b-76bd-82ef-841657c3f805.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://mainstreetmovies5.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17646771993279444709&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "main-street-movies-5",
      "poi_latitude": "39.6861757",
      "poi_longitude": "-75.7444478",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 302-455-2482",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-b808-7372-82e8-12987610180a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-b808-7372-82e8-12987610180a",
        "storage_key": "property/6767906449166328/019d0268-b808-7372-82e8-12987610180a.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJd3T9ZTmqx4kR5ba7m6Ht5fQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_86250b54-182f-4ca7-837d-ebc2d0efa201",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "poi_name": "Iron Hill School Museum",
      "poi_type": "Entertainment",
      "poi_address": "1359-1365 S Old Baltimore Pike, Newark, DE 19702, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-6a27-76ae-8d33-7619ac3eaab8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-6a27-76ae-8d33-7619ac3eaab8",
        "storage_key": "property/6767906449166328/019d0268-6a27-76ae-8d33-7619ac3eaab8.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.ironhillsciencecenter.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7513841319038420739&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "iron-hill-school-museum",
      "poi_latitude": "39.631555",
      "poi_longitude": "-75.758196",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 14 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 302-368-5703",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-b809-7065-abe9-be4149d1e25c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-b809-7065-abe9-be4149d1e25c",
        "storage_key": "property/6767906449166328/019d0268-b809-7065-abe9-be4149d1e25c.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJrTR7LVWox4kRAwfwn96GRmg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_fc196a9a-346e-4445-8c3a-fb3911a1b43b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "poi_name": "White Clay Creek State Park",
      "poi_type": "Entertainment",
      "poi_address": "Park Office, 750 Thompson Station Rd, Newark, DE 19711, USA",
      "poi_short_description": "Park featuring 37 miles of hiking & biking trails along with fishing streams & a nature center.",
      "poi_long_description": "Park featuring 37 miles of hiking & biking trails along with fishing streams & a nature center.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-6e0d-74bc-94dc-ee36bf8f386f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-6e0d-74bc-94dc-ee36bf8f386f",
        "storage_key": "property/6767906449166328/019d0268-6e0d-74bc-94dc-ee36bf8f386f.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.destateparks.com/park/white-clay-creek/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17516642154323962018&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "white-clay-creek-state-park",
      "poi_latitude": "39.7348663",
      "poi_longitude": "-75.7580196",
      "poi_miles_from_property": "8.4",
      "poi_walking_minutes": "3 hours 13 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 302-368-6900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-bb69-730b-9b13-01d0b683bda5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-bb69-730b-9b13-01d0b683bda5",
        "storage_key": "property/6767906449166328/019d0268-bb69-730b-9b13-01d0b683bda5.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7Q5sP_2qx4kRougccjudF_M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "state_park"
    },
    {
      "id": "custom_2998d8e2-3bb1-4582-9861-49d0a97df82e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "poi_name": "Newark Arts Alliance Inc",
      "poi_type": "Entertainment",
      "poi_address": "207 Louviers Dr, Newark, DE 19711, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-71d1-720e-bf60-7fce51805b96.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-71d1-720e-bf60-7fce51805b96",
        "storage_key": "property/6767906449166328/019d0268-71d1-720e-bf60-7fce51805b96.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.newarkartsalliance.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9684259832307363587&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "newark-arts-alliance-inc",
      "poi_latitude": "39.7111037",
      "poi_longitude": "-75.74193129999999",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 28 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 302-266-7266",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-bb7c-743d-a495-980a1c11b849.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-bb7c-743d-a495-980a1c11b849",
        "storage_key": "property/6767906449166328/019d0268-bb7c-743d-a495-980a1c11b849.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJORpRazyqx4kRA69DEQJnZYY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_c8b6124b-fc77-40fc-abd7-d7a542b10a9d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "poi_name": "Newark Historical Society",
      "poi_type": "Entertainment",
      "poi_address": "429 S College Ave, Newark, DE 19711, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-7003-706c-bb14-c401b678007a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-7003-706c-bb14-c401b678007a",
        "storage_key": "property/6767906449166328/019d0268-7003-706c-bb14-c401b678007a.webp",
        "width": 1090,
        "height": 695
      },
      "poi_business_url": "https://newarkhistorymuseumde.weebly.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11744084243832817558&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "newark-historical-society",
      "poi_latitude": "39.6741791",
      "poi_longitude": "-75.7502969",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 302-224-2408",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-bb7c-743d-a495-980a1c11b849.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-bb7c-743d-a495-980a1c11b849",
        "storage_key": "property/6767906449166328/019d0268-bb7c-743d-a495-980a1c11b849.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOx1j8D2qx4kRlsfqnWVe-6I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_988fee6a-5744-400a-b65e-3a656d5efe3d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "poi_name": "240 Old Paper Mill Rd",
      "poi_type": "Entertainment",
      "poi_address": "240 Old Paper Mill Rd, Newark, DE 19711, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=10855646323213393988&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "240-old-paper-mill-rd",
      "poi_latitude": "39.69065",
      "poi_longitude": "-75.74696089999999",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-bb7c-743d-a495-980a1c11b849.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-bb7c-743d-a495-980a1c11b849",
        "storage_key": "property/6767906449166328/019d0268-bb7c-743d-a495-980a1c11b849.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJixnVdjiqx4kRROBottAAp5Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_95b7c981-1794-410a-8c6c-f226ba192fe5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "poi_name": "Thompson Theatre at Roselle Center for the Arts University of Delaware from Main Street",
      "poi_type": "Entertainment",
      "poi_address": "110 Orchard Rd, Newark, DE 19716, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.udel.edu/academics/colleges/cas/units/departments/school-of-music/about-us/our-venues/roselle-center-for-arts/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5384228206901598353&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "thompson-theatre-at-roselle-center-for-the-arts-university-of-delaware-from-main-street",
      "poi_latitude": "39.679291",
      "poi_longitude": "-75.757277",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 6 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-bb7c-743d-a495-980a1c11b849.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-bb7c-743d-a495-980a1c11b849",
        "storage_key": "property/6767906449166328/019d0268-bb7c-743d-a495-980a1c11b849.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJC4WUcQGrx4kRkRgC_gafuEo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_b8848112-fc3c-4f8e-b0d4-f3a8c78c157b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "poi_name": "ChristianaCare Christiana Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "4755 Ogletown Stanton Rd, Newark, DE 19718, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-7154-711d-844a-b14ea5db9572.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-7154-711d-844a-b14ea5db9572",
        "storage_key": "property/6767906449166328/019d0268-7154-711d-844a-b14ea5db9572.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://christianacare.org/facilities/christianahospital/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16495470270249753645&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "christianacare-christiana-hospital",
      "poi_latitude": "39.6885738",
      "poi_longitude": "-75.67117739999999",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 302-733-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-bba2-741a-a5e3-bcdb7ebcbf49.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-bba2-741a-a5e3-bcdb7ebcbf49",
        "storage_key": "property/6767906449166328/019d0268-bba2-741a-a5e3-bcdb7ebcbf49.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJCbcdfuEAx4kRLdxAZdCu6-Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_cda6245b-80fe-4ff3-af7d-d60ef243e3d7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "poi_name": "ChristianaCare-GoHealth Urgent Care",
      "poi_type": "Health and Wellness",
      "poi_address": "2645 Pulaski Hwy Suite A, Newark, DE 19702, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-78fb-746d-a9f3-0a58b151d378.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-78fb-746d-a9f3-0a58b151d378",
        "storage_key": "property/6767906449166328/019d0268-78fb-746d-a9f3-0a58b151d378.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.gohealthuc.com/christianacare/locations/glasgow?utm_source=gmb&utm_medium=organic&utm_content=cc-glasgow",
      "poi_directions_map_url": "https://maps.google.com/?cid=5218281587080206593&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "christianacare-gohealth-urgent-care",
      "poi_latitude": "39.604485",
      "poi_longitude": "-75.75527799999999",
      "poi_miles_from_property": "9.1",
      "poi_walking_minutes": "3 hours 21 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 302-273-1317",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-bb7c-743d-a495-980a1c11b849.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-bb7c-743d-a495-980a1c11b849",
        "storage_key": "property/6767906449166328/019d0268-bb7c-743d-a495-980a1c11b849.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCbQM0HGox4kRAZngr3QPa0g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "custom_8a7e6111-c83a-4112-b337-f311dd009a16",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "poi_name": "GLASGOW PHARMACY",
      "poi_type": "Health and Wellness",
      "poi_address": "3625 Wrangle Hill Rd, Bear, DE 19701, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-78e1-768d-88f6-877b4879c30e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-78e1-768d-88f6-877b4879c30e",
        "storage_key": "property/6767906449166328/019d0268-78e1-768d-88f6-877b4879c30e.webp",
        "width": 1080,
        "height": 607
      },
      "poi_business_url": "https://www.glasgowpharmacy.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10175508398754718217&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "glasgow-pharmacy",
      "poi_latitude": "39.5842459",
      "poi_longitude": "-75.6836412",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 37 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 302-838-8700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-b809-7065-abe9-c1bbd1b45ad8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-b809-7065-abe9-c1bbd1b45ad8",
        "storage_key": "property/6767906449166328/019d0268-b809-7065-abe9-c1bbd1b45ad8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJS2GV23Gox4kRCWLH_PmqNo0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_cfbe7596-2f22-4d1b-a597-dbe2c10f861b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "poi_name": "Rite Aid Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "400 Peoples Plaza, Newark, DE 19702, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-7951-74a9-b834-7d445b27a3b7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-7951-74a9-b834-7d445b27a3b7",
        "storage_key": "property/6767906449166328/019d0268-7951-74a9-b834-7d445b27a3b7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.riteaid.com/locations/de/newark/400-peoples-plaza.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=13661489874263427106&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rite-aid-pharmacy",
      "poi_latitude": "39.6024665",
      "poi_longitude": "-75.74527979999999",
      "poi_miles_from_property": "9.7",
      "poi_walking_minutes": "3 hours 35 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 302-834-0532",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-b809-7065-abe9-c1bbd1b45ad8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-b809-7065-abe9-c1bbd1b45ad8",
        "storage_key": "property/6767906449166328/019d0268-b809-7065-abe9-c1bbd1b45ad8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9yr32m6ox4kRIkgRsqhcl70",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_89f83aec-40e5-432b-81f4-3266c2093531",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "53 Marrows Rd, Newark, DE 19713, USA",
      "poi_short_description": "Chain fitness center offering a range of equipment and tanning services, as well as massage chairs.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-78e2-77af-b538-28fc175a0e5b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-78e2-77af-b538-28fc175a0e5b",
        "storage_key": "property/6767906449166328/019d0268-78e2-77af-b538-28fc175a0e5b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/newark-de?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=5450099418853468891&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "39.664848",
      "poi_longitude": "-75.7257338",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 302-731-7360",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-bb7c-743d-a495-980a1c11b849.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-bb7c-743d-a495-980a1c11b849",
        "storage_key": "property/6767906449166328/019d0268-bb7c-743d-a495-980a1c11b849.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJd2IxQPepx4kR2-pSq4ukoks",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_e7952f8f-8d79-487c-8303-7391f76623e2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "poi_name": "Crunch Fitness - Newark",
      "poi_type": "Health and Wellness",
      "poi_address": "400 Grove Ln, Newark, DE 19711, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-80d5-760a-8df5-4a2de1284b50.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-80d5-760a-8df5-4a2de1284b50",
        "storage_key": "property/6767906449166328/019d0268-80d5-760a-8df5-4a2de1284b50.webp",
        "width": 1225,
        "height": 800
      },
      "poi_business_url": "https://www.crunch.com/locations/newark",
      "poi_directions_map_url": "https://maps.google.com/?cid=16558164109099067745&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "crunch-fitness---newark",
      "poi_latitude": "39.6828366",
      "poi_longitude": "-75.7329117",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 302-366-4061",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-bb7c-743d-a495-980a1c11b849.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-bb7c-743d-a495-980a1c11b849",
        "storage_key": "property/6767906449166328/019d0268-bb7c-743d-a495-980a1c11b849.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJC3MPJGirx4kRYel4P4dqyuU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_b90598ba-e21e-4239-91a8-4c770fe18e34",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "poi_name": "9Round Fitness Newark",
      "poi_type": "Health and Wellness",
      "poi_address": "2826 Pulaski Hwy, Newark, DE 19702, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-80cb-73b0-abe2-14e0c5f9472a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-80cb-73b0-abe2-14e0c5f9472a",
        "storage_key": "property/6767906449166328/019d0268-80cb-73b0-abe2-14e0c5f9472a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.9round.com/NewarkPleasantValleyCrossing",
      "poi_directions_map_url": "https://maps.google.com/?cid=6017429981925599585&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "9round-fitness-newark",
      "poi_latitude": "39.6042518",
      "poi_longitude": "-75.76871",
      "poi_miles_from_property": "8.4",
      "poi_walking_minutes": "3 hours 7 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 302-365-5590",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-bb7c-743d-a495-980a1c11b849.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-bb7c-743d-a495-980a1c11b849",
        "storage_key": "property/6767906449166328/019d0268-bb7c-743d-a495-980a1c11b849.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmfg5OYiox4kRYel11a80glM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_7e6b8b6e-12f7-4849-a04e-1a2b421519eb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "poi_name": "Bear-Glasgow Family YMCA",
      "poi_type": "Health and Wellness",
      "poi_address": "351 George Williams Way, Newark, DE 19702, USA",
      "poi_short_description": "Clean sports facility, featuring an indoor pool and an outdoor pool, plus exercise classes for all ages.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-829e-739a-ac65-3f7c4db4b993.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-829e-739a-ac65-3f7c4db4b993",
        "storage_key": "property/6767906449166328/019d0268-829e-739a-ac65-3f7c4db4b993.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.ymcade.org/locations/bear-glasgow-ymca/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16440345375663294436&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bear-glasgow-family-ymca",
      "poi_latitude": "39.605539",
      "poi_longitude": "-75.732465",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 46 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 302-836-9622",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-bb7c-743d-a495-980a1c11b849.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-bb7c-743d-a495-980a1c11b849",
        "storage_key": "property/6767906449166328/019d0268-bb7c-743d-a495-980a1c11b849.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1zSGNBSox4kR5IcltQPXJ-Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_8f5c4c99-89f7-4310-bab0-7e12cb9fafa7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "poi_name": "Premier Physical Therapy & Sports Performance - Bear",
      "poi_type": "Health and Wellness",
      "poi_address": "1456 Pulaski Hwy, Newark, DE 19702, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-829e-739a-ac65-369e16a32cf0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-829e-739a-ac65-369e16a32cf0",
        "storage_key": "property/6767906449166328/019d0268-829e-739a-ac65-369e16a32cf0.webp",
        "width": 1280,
        "height": 963
      },
      "poi_business_url": "http://www.premierptsp.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=430247809511596703&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "premier-physical-therapy--sports-performance---bear",
      "poi_latitude": "39.6229668",
      "poi_longitude": "-75.68275899999999",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 302-440-6161",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-bb7c-743d-a495-980a1c11b849.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-bb7c-743d-a495-980a1c11b849",
        "storage_key": "property/6767906449166328/019d0268-bb7c-743d-a495-980a1c11b849.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJx7gFoOYHx4kRnyJUaxqM-AU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "custom_f9f916e5-de5e-4cab-a083-5e90fbb94c5b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "poi_name": "242 Old Paper Mill Rd",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "242 Old Paper Mill Rd, Newark, DE 19711, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?q=242+Old+Paper+Mill+Rd,+Newark,+DE+19711,+USA&ftid=0x89c7aa4768a6e08f:0x678db9ec00330e03&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "242-old-paper-mill-rd",
      "poi_latitude": "39.6912834",
      "poi_longitude": "-75.74523719999999",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-bb7c-743d-a495-980a1c11b849.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-bb7c-743d-a495-980a1c11b849",
        "storage_key": "property/6767906449166328/019d0268-bb7c-743d-a495-980a1c11b849.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "EiwyNDIgT2xkIFBhcGVyIE1pbGwgUmQsIE5ld2FyaywgREUgMTk3MTEsIFVTQSIxEi8KFAoSCY_gpmhHqseJEZValE148rSYEPIBKhQKEgkHPH8zR6rHiRF6ja_zWp2X4Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_c1cc87be-8323-4fa5-9c2f-399751b927c0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "poi_name": "William M. Redd, Jr. Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "500 Paper Mill Rd, Newark, DE 19711, USA",
      "poi_short_description": "Well-maintained park for walking and biking on paved and dirt trails, plus dense forest and a reservoir loop.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-883b-76a9-b953-5436d4beba3a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-883b-76a9-b953-5436d4beba3a",
        "storage_key": "property/6767906449166328/019d0268-883b-76a9-b953-5436d4beba3a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=8102764489306844726&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "william-m-redd-jr-park",
      "poi_latitude": "39.7011177",
      "poi_longitude": "-75.7422368",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 17 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 302-366-7700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-bb69-730b-9b13-01d0b683bda5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-bb69-730b-9b13-01d0b683bda5",
        "storage_key": "property/6767906449166328/019d0268-bb69-730b-9b13-01d0b683bda5.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8b60p16qx4kRNq7Ia1_NcnA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_6ddd5ad5-e231-4f88-92a4-32594157a55f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "poi_name": "Kershaw Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "197 Paper Mill Rd, Newark, DE 19711, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-8a83-75ab-a712-97b1e8baf39f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-8a83-75ab-a712-97b1e8baf39f",
        "storage_key": "property/6767906449166328/019d0268-8a83-75ab-a712-97b1e8baf39f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://newarkde.gov/454/Kershaw-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=10642632878138314835&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kershaw-park",
      "poi_latitude": "39.6881183",
      "poi_longitude": "-75.75099329999999",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 302-366-7147",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-bb69-730b-9b13-01d0b683bda5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-bb69-730b-9b13-01d0b683bda5",
        "storage_key": "property/6767906449166328/019d0268-bb69-730b-9b13-01d0b683bda5.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJQbK3IMurx4kRU9BTMDc6spM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_f5444da6-d863-41f9-81df-242c2f896825",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "poi_name": "Curtis Mill Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "299 Paper Mill Rd #287, Newark, DE 19711, USA",
      "poi_short_description": "City park established on a former paper-mill site, offering trail access & picnic areas.",
      "poi_long_description": "City park established on a former paper-mill site, offering trail access & picnic areas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-8a68-738e-ad63-54e9736cd2c9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-8a68-738e-ad63-54e9736cd2c9",
        "storage_key": "property/6767906449166328/019d0268-8a68-738e-ad63-54e9736cd2c9.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://gis.cityofnewarkde.us/gis/parks",
      "poi_directions_map_url": "https://maps.google.com/?cid=12960202848480035618&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "curtis-mill-park",
      "poi_latitude": "39.6910337",
      "poi_longitude": "-75.7497269",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 302-366-7060",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-bb69-730b-9b13-01d0b683bda5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-bb69-730b-9b13-01d0b683bda5",
        "storage_key": "property/6767906449166328/019d0268-bb69-730b-9b13-01d0b683bda5.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJz0uF4zeqx4kRIoOoGNPj27M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_3801128d-2ba0-4c43-8e83-8df726274d21",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "poi_name": "Old Paper Mill Road Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "240 Old Paper Mill Rd, Newark, DE 19711, USA",
      "poi_short_description": "Charming 12-acre park in verdant, natural surrounds featuring a paved trail loop & reservoir.",
      "poi_long_description": "Charming 12-acre park in verdant, natural surrounds featuring a paved trail loop & reservoir.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-8c37-732e-a797-294460583e4e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-8c37-732e-a797-294460583e4e",
        "storage_key": "property/6767906449166328/019d0268-8c37-732e-a797-294460583e4e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://newarkde.gov/462/Old-Paper-Mill-Road-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=9638895221254577931&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "old-paper-mill-road-park",
      "poi_latitude": "39.6906208",
      "poi_longitude": "-75.7468055",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 302-366-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-bb69-730b-9b13-01d0b683bda5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-bb69-730b-9b13-01d0b683bda5",
        "storage_key": "property/6767906449166328/019d0268-bb69-730b-9b13-01d0b683bda5.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJixnVdjiqx4kRC98WeiI8xIU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_41df3246-aa4e-4f60-bd70-92e4fe9407b7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "poi_name": "Judge Morris Estate - White Clay Creek State Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "76 Polly Drummond Hill Rd, Newark, DE 19711, USA",
      "poi_short_description": "Scenic park featuring an estate, loops and meadow trails and ponds for fishing.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-91f0-76f4-8d1e-0ea15bc3bf73.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-91f0-76f4-8d1e-0ea15bc3bf73",
        "storage_key": "property/6767906449166328/019d0268-91f0-76f4-8d1e-0ea15bc3bf73.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://destateparks.com/WhiteClayCreek",
      "poi_directions_map_url": "https://maps.google.com/?cid=14793577624174711425&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "judge-morris-estate---white-clay-creek-state-park",
      "poi_latitude": "39.703524",
      "poi_longitude": "-75.7083816",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 302-368-6900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-bb69-730b-9b13-01d0b683bda5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-bb69-730b-9b13-01d0b683bda5",
        "storage_key": "property/6767906449166328/019d0268-bb69-730b-9b13-01d0b683bda5.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJu6uVvoAAx4kRgdIZLnhYTc0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_01fa9463-f7a5-4595-bdae-b0998426aa89",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "poi_name": "Middle Run Valley Natural Area",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "170 Possum Hollow Rd, Newark, DE 19711, USA",
      "poi_short_description": "850-acre state park offering 10 trails over 16 miles, plus the historic John C. Vansant house",
      "poi_long_description": "850-acre state park offering 10 trails over 16 miles, plus the historic John C. Vansant house",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-952b-745c-bd33-0cd97f1eb68f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-952b-745c-bd33-0cd97f1eb68f",
        "storage_key": "property/6767906449166328/019d0268-952b-745c-bd33-0cd97f1eb68f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.delawarenaturesociety.org/centers/middle-run-natural-area/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1856464872919397726&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "middle-run-valley-natural-area",
      "poi_latitude": "39.7156633",
      "poi_longitude": "-75.7241994",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 302-395-5606",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-bb69-730b-9b13-01d0b683bda5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-bb69-730b-9b13-01d0b683bda5",
        "storage_key": "property/6767906449166328/019d0268-bb69-730b-9b13-01d0b683bda5.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJVZ2TdIeqx4kRXvVZSPd8wxk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_34171ed8-b71e-4e04-9342-c91bc0d347c0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "poi_name": "Deacons Walk Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "9 Ware Rd, Newark, DE 19711, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-94bd-7259-9dcf-05021e1b3336.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-94bd-7259-9dcf-05021e1b3336",
        "storage_key": "property/6767906449166328/019d0268-94bd-7259-9dcf-05021e1b3336.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.newcastlede.gov/facilities/facility/details/Deacons-Walk-Park-65",
      "poi_directions_map_url": "https://maps.google.com/?cid=3986435720252847931&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "deacons-walk-park",
      "poi_latitude": "39.725586",
      "poi_longitude": "-75.703769",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 302-395-5606",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-bb69-730b-9b13-01d0b683bda5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-bb69-730b-9b13-01d0b683bda5",
        "storage_key": "property/6767906449166328/019d0268-bb69-730b-9b13-01d0b683bda5.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJFxKvkEMBx4kRO3eZoSqqUjc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_ffdffba9-961a-445a-b91a-b2a5b9a291c5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "poi_name": "Lewis Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "727 Academy St, Newark, DE 19711, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-9778-71c9-b4dd-60a6c0deca00.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-9778-71c9-b4dd-60a6c0deca00",
        "storage_key": "property/6767906449166328/019d0268-9778-71c9-b4dd-60a6c0deca00.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://newarkde.gov/456/Lewis-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=6151362064954740087&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lewis-park",
      "poi_latitude": "39.672227",
      "poi_longitude": "-75.7503727",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 7 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 302-366-7060",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-bb69-730b-9b13-01d0b683bda5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-bb69-730b-9b13-01d0b683bda5",
        "storage_key": "property/6767906449166328/019d0268-bb69-730b-9b13-01d0b683bda5.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJPd733Ceqx4kRd81w7jQHXlU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_33374f39-828a-4379-9261-08bcce58680a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "poi_name": "Folk Memorial Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "98 Welsh Tract Rd, Newark, DE 19713, USA",
      "poi_short_description": "Baseball field joined with tennis courts, kids' play areas and walking lawns.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-9ae6-762c-90a6-b155f9deeeed.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-9ae6-762c-90a6-b155f9deeeed",
        "storage_key": "property/6767906449166328/019d0268-9ae6-762c-90a6-b155f9deeeed.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://newarkde.gov/429/Folk-Memorial-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=6923620823375863912&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "folk-memorial-park",
      "poi_latitude": "39.6482281",
      "poi_longitude": "-75.75768819999999",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 302-366-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-bb69-730b-9b13-01d0b683bda5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-bb69-730b-9b13-01d0b683bda5",
        "storage_key": "property/6767906449166328/019d0268-bb69-730b-9b13-01d0b683bda5.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJI94gusypx4kRaODQuHSkFWA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_e94a4e60-4ae3-4207-a6e1-3e894b1a4dfc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "poi_name": "Newark",
      "poi_type": "Transportation & Transit",
      "poi_address": "10 Mopar Dr, Newark, DE 19713, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-9c6d-77c2-ae34-0c1975ffb33e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-9c6d-77c2-ae34-0c1975ffb33e",
        "storage_key": "property/6767906449166328/019d0268-9c6d-77c2-ae34-0c1975ffb33e.webp",
        "width": 964,
        "height": 1280
      },
      "poi_business_url": "https://www.amtrak.com/servlet/ContentServer?pagename=am/am2Station/Station_Page&code=NRK",
      "poi_directions_map_url": "https://maps.google.com/?cid=10072551141323619632&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "newark",
      "poi_latitude": "39.6700728",
      "poi_longitude": "-75.75275169999999",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 800-872-7245",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-bbcd-778e-80a8-322b6f9dd66a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-bbcd-778e-80a8-322b6f9dd66a",
        "storage_key": "property/6767906449166328/019d0268-bbcd-778e-80a8-322b6f9dd66a.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJVeSwaoepx4kRML2MeOXjyIs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_6461d98f-0e9f-4025-bc13-89214ff15bcb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "poi_name": "Newark Transit Hub",
      "poi_type": "Transportation & Transit",
      "poi_address": "Newark, DE 19711, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-9ecd-777d-b49b-ece27b7d9245.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-9ecd-777d-b49b-ece27b7d9245",
        "storage_key": "property/6767906449166328/019d0268-9ecd-777d-b49b-ece27b7d9245.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=16807474905555561595&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "newark-transit-hub",
      "poi_latitude": "39.6824772",
      "poi_longitude": "-75.7435319",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-bb7c-743d-a495-980a1c11b849.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-bb7c-743d-a495-980a1c11b849",
        "storage_key": "property/6767906449166328/019d0268-bb7c-743d-a495-980a1c11b849.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJr9LiZDuqx4kRe2zudGAlQOk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_2c7515dc-1d59-4f38-af85-4cde3ce0e1a9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "poi_name": "Christiana Mall Park & Ride (Inside)",
      "poi_type": "Transportation & Transit",
      "poi_address": "Christiana, DE 19702, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-a250-74ae-a417-a585a37adc54.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-a250-74ae-a417-a585a37adc54",
        "storage_key": "property/6767906449166328/019d0268-a250-74ae-a417-a585a37adc54.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=12965177574651476672&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "christiana-mall-park--ride-inside",
      "poi_latitude": "39.67993200000001",
      "poi_longitude": "-75.655795",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-bb7c-743d-a495-980a1c11b849.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-bb7c-743d-a495-980a1c11b849",
        "storage_key": "property/6767906449166328/019d0268-bb7c-743d-a495-980a1c11b849.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJGfoXAhgBx4kRwDr2yk-Q7bM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_ce8f44ce-d606-4119-9dee-d92f2bbc3f1d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "poi_name": "Wilmington Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "151 N Dupont Hwy, New Castle, DE 19720, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-a39d-73f8-82a2-e0a1f088d68d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-a39d-73f8-82a2-e0a1f088d68d",
        "storage_key": "property/6767906449166328/019d0268-a39d-73f8-82a2-e0a1f088d68d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://flyilg.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1083455709425976738&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wilmington-airport",
      "poi_latitude": "39.6790169",
      "poi_longitude": "-75.60703960000001",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 302-325-5124",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-bff0-754d-af50-056658ee99b7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-bff0-754d-af50-056658ee99b7",
        "storage_key": "property/6767906449166328/019d0268-bff0-754d-af50-056658ee99b7.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJMbyqscQDx4kRokU0Mjo1CQ8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_2138c08f-0c86-422d-8051-9e7de0dc7595",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "poi_name": "Wilmington",
      "poi_type": "Transportation & Transit",
      "poi_address": "100 French St, Wilmington, DE 19801, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-a3c1-75cb-a805-7856de44c994.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-a3c1-75cb-a805-7856de44c994",
        "storage_key": "property/6767906449166328/019d0268-a3c1-75cb-a805-7856de44c994.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amtrak.com/servlet/ContentServer?pagename=am/am2Station/Station_Page&code=WIL",
      "poi_directions_map_url": "https://maps.google.com/?cid=7825201090715334340&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wilmington",
      "poi_latitude": "39.7371953",
      "poi_longitude": "-75.5512614",
      "poi_miles_from_property": "11.5",
      "poi_walking_minutes": "4 hours 15 mins",
      "poi_biking_minutes": "1 hour 11 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-bbcd-778e-80a8-322b6f9dd66a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-bbcd-778e-80a8-322b6f9dd66a",
        "storage_key": "property/6767906449166328/019d0268-bbcd-778e-80a8-322b6f9dd66a.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJbZWF-2f9xokRxDYWrO6ymGw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_578416b8-2820-4e1d-88c8-1a8b5990e32e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "poi_name": "8000 Essington Ave",
      "poi_type": "Transportation & Transit",
      "poi_address": "8000 Essington Ave, Philadelphia, PA 19153, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=3940177627801768097&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "8000-essington-ave",
      "poi_latitude": "39.8709941",
      "poi_longitude": "-75.26416499999999",
      "poi_miles_from_property": "30.9",
      "poi_walking_minutes": "11 hours 24 mins",
      "poi_biking_minutes": "3 hours 0 mins",
      "poi_driving_minutes": "33 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-bb7c-743d-a495-980a1c11b849.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-bb7c-743d-a495-980a1c11b849",
        "storage_key": "property/6767906449166328/019d0268-bb7c-743d-a495-980a1c11b849.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJi6RdEkLDxokRodAQMa1SrjY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "premise"
    },
    {
      "id": "custom_612f993b-6434-4b61-9572-7fbe3dec0034",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "poi_name": "Trabant University Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "17 W Main St, Newark, DE 19716, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-a61b-7047-93c3-a94d7264a3a3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-a61b-7047-93c3-a94d7264a3a3",
        "storage_key": "property/6767906449166328/019d0268-a61b-7047-93c3-a94d7264a3a3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://sites.udel.edu/usc/buildings/trabant/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16809220960971290734&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "trabant-university-center",
      "poi_latitude": "39.6824535",
      "poi_longitude": "-75.7543749",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 302-831-2633",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-bb7c-743d-a495-980a1c11b849.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-bb7c-743d-a495-980a1c11b849",
        "storage_key": "property/6767906449166328/019d0268-bb7c-743d-a495-980a1c11b849.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJp3xw9zGqx4kRbni-qWdZRuk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_ee97aa97-066a-499a-940b-5b1939baf220",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "poi_name": "De 273 & De 7 Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "Christiana, DE 19702, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-a7c3-75d9-a748-7e46c3d82bf8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-a7c3-75d9-a748-7e46c3d82bf8",
        "storage_key": "property/6767906449166328/019d0268-a7c3-75d9-a748-7e46c3d82bf8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=11811477746743553905&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "de-273--de-7-park--ride",
      "poi_latitude": "39.66161",
      "poi_longitude": "-75.654566",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-bb7c-743d-a495-980a1c11b849.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-bb7c-743d-a495-980a1c11b849",
        "storage_key": "property/6767906449166328/019d0268-bb7c-743d-a495-980a1c11b849.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJncs9ijIBx4kRca8UR27M6qM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_ddecb7a9-eaf6-418f-91d9-196c4231883b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "poi_name": "Peoples Plaza Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "Glasgow, DE 19702, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=2129394718175761353&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "peoples-plaza-park--ride",
      "poi_latitude": "39.602733",
      "poi_longitude": "-75.74602999999999",
      "poi_miles_from_property": "9.7",
      "poi_walking_minutes": "3 hours 34 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-bfee-7234-90b0-fb7d3bf74bec.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-bfee-7234-90b0-fb7d3bf74bec",
        "storage_key": "property/6767906449166328/019d0268-bfee-7234-90b0-fb7d3bf74bec.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJqbQ5Am-ox4kRyZN10zYhjR0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_station"
    },
    {
      "id": "custom_f35ff888-d9b5-41c2-a71a-afcd77b92f87",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "poi_name": "W. L. Gore & Associates, Inc. - Paper Mill East",
      "poi_type": "Major Employers & Offices",
      "poi_address": "551 Paper Mill Rd, Newark, DE 19711, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.gore.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13417982219775503895&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "w-l-gore--associates-inc---paper-mill-east",
      "poi_latitude": "39.708123",
      "poi_longitude": "-75.7462692",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 34 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 302-738-4880",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-bb7c-743d-a495-980a1c11b849.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-bb7c-743d-a495-980a1c11b849",
        "storage_key": "property/6767906449166328/019d0268-bb7c-743d-a495-980a1c11b849.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJEXxbxSDxDogRF-45xLw_Nro",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_c2d3ce9f-7a88-4bdd-8e98-be931b711575",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "poi_name": "Bloom Energy",
      "poi_type": "Major Employers & Offices",
      "poi_address": "200 Christina Pkwy, Newark, DE 19713, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-a924-71cc-9cd6-43e6e8660c49.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-a924-71cc-9cd6-43e6e8660c49",
        "storage_key": "property/6767906449166328/019d0268-a924-71cc-9cd6-43e6e8660c49.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.bloomenergy.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4029729552371595301&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bloom-energy",
      "poi_latitude": "39.6615544",
      "poi_longitude": "-75.7600665",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 14 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 302-533-3650",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-bb7c-743d-a495-980a1c11b849.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-bb7c-743d-a495-980a1c11b849",
        "storage_key": "property/6767906449166328/019d0268-bb7c-743d-a495-980a1c11b849.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJkU3iXJ2px4kRJbgAbq157Dc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_3a5bc539-ed80-4eda-ba54-5a43f23cdb80",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "poi_name": "Chemours Discovery Hub",
      "poi_type": "Major Employers & Offices",
      "poi_address": "201 Discovery Blvd, Newark, DE 19713, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-aaca-721d-b205-f641e5fe3c76.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-aaca-721d-b205-f641e5fe3c76",
        "storage_key": "property/6767906449166328/019d0268-aaca-721d-b205-f641e5fe3c76.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://chemours.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7651315567940895185&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chemours-discovery-hub",
      "poi_latitude": "39.6621602",
      "poi_longitude": "-75.75550620000001",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 11 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 866-828-7009",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-bb7c-743d-a495-980a1c11b849.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-bb7c-743d-a495-980a1c11b849",
        "storage_key": "property/6767906449166328/019d0268-bb7c-743d-a495-980a1c11b849.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJO6d_Pf6px4kR0YGIe_juLmo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_01075865-05d8-4ff1-bd9c-d3053687648c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "poi_name": "NIIMBL: National Institute for Innovation in Manufacturing Biopharmaceuticals",
      "poi_type": "Major Employers & Offices",
      "poi_address": "590 Avenue 1743, Newark, DE 19713, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.niimbl.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14557755210893600259&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "niimbl-national-institute-for-innovation-in-manufacturing-biopharmaceuticals",
      "poi_latitude": "39.66328439999999",
      "poi_longitude": "-75.75587430000002",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-bb7c-743d-a495-980a1c11b849.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-bb7c-743d-a495-980a1c11b849",
        "storage_key": "property/6767906449166328/019d0268-bb7c-743d-a495-980a1c11b849.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJMQV3IhWpx4kRA6Zn6DuJB8o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_00926039-9fb7-415d-8574-688ecc02d166",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "poi_name": "Ammon Pinizzotto Biopharmaceutical Innovation Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "590 Avenue 1743, Newark, DE 19713, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-ac4d-756b-b560-fc23e695f860.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-ac4d-756b-b560-fc23e695f860",
        "storage_key": "property/6767906449166328/019d0268-ac4d-756b-b560-fc23e695f860.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=9879095275148873404&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ammon-pinizzotto-biopharmaceutical-innovation-center",
      "poi_latitude": "39.6632843",
      "poi_longitude": "-75.7559015",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-b80e-74cc-b94d-1290689395ca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-b80e-74cc-b94d-1290689395ca",
        "storage_key": "property/6767906449166328/019d0268-b80e-74cc-b94d-1290689395ca.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ_er1A-Kpx4kRvA59oc-YGYk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d67f6658-076e-473a-a411-f48682349aa5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "poi_name": "FinTech Innovation Hub",
      "poi_type": "Major Employers & Offices",
      "poi_address": "591 Collaboration Way, Newark, DE 19713, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.udel.edu/research-innovation/star/fintech/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3649286553478952688&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fintech-innovation-hub",
      "poi_latitude": "39.6631055",
      "poi_longitude": "-75.7576441",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-b80e-74cc-b94d-1290689395ca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-b80e-74cc-b94d-1290689395ca",
        "storage_key": "property/6767906449166328/019d0268-b80e-74cc-b94d-1290689395ca.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ99c0126rx4kR8Pa4H8nepDI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_d845209d-62fc-4ef9-be3f-a7f5e6f0837d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "poi_name": "Charles River",
      "poi_type": "Major Employers & Offices",
      "poi_address": "614 Interchange Blvd, Newark, DE 19711, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-ad93-701b-8acd-6721f017fea8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-ad93-701b-8acd-6721f017fea8",
        "storage_key": "property/6767906449166328/019d0268-ad93-701b-8acd-6721f017fea8.webp",
        "width": 800,
        "height": 532
      },
      "poi_business_url": "https://www.criver.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12091981929345963991&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "charles-river",
      "poi_latitude": "39.6581452",
      "poi_longitude": "-75.7794747",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 42 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 302-292-8888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-bb7c-743d-a495-980a1c11b849.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-bb7c-743d-a495-980a1c11b849",
        "storage_key": "property/6767906449166328/019d0268-bb7c-743d-a495-980a1c11b849.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJV6kkN1yox4kR19cbqX9Zz6c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_541e8a41-e7ee-44f2-8e91-0e9042b622e3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "poi_name": "Delaware Technical Community College - Stanton Campus - Newark",
      "poi_type": "Major Employers & Offices",
      "poi_address": "400 Stanton Christiana Rd d201, Newark, DE 19713, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-aea8-7778-8dfa-2693ae6abf61.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-aea8-7778-8dfa-2693ae6abf61",
        "storage_key": "property/6767906449166328/019d0268-aea8-7778-8dfa-2693ae6abf61.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.dtcc.edu/our-campuses/stanton",
      "poi_directions_map_url": "https://maps.google.com/?cid=15633881627870143609&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "delaware-technical-community-college---stanton-campus---newark",
      "poi_latitude": "39.6891998",
      "poi_longitude": "-75.6487862",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 302-454-3900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0268-b80e-74cc-b94d-1290689395ca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-b80e-74cc-b94d-1290689395ca",
        "storage_key": "property/6767906449166328/019d0268-b80e-74cc-b94d-1290689395ca.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJB_JnGBABx4kReaS0OYK09tg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    }
  ],
  "office_hours": [
    {
      "id": "custom_c9a68059-71ed-4bd8-9dff-463052380e70",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_8ac2975f-060d-4553-adf0-ce4db8400532",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_605d4df3-57fb-42d8-ab8c-8ce20391df96",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_af07bde3-3b38-4dea-934f-41897ed60ec1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_013277d2-a027-4d23-97ed-24637a7e5803",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_7080e2f9-aaa8-4200-9564-1e0d788dbca5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_9ea7eebf-c4d1-4d78-b215-a5c8d57526d4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "rating": "5.0",
      "name": "Thomas Wisniewski",
      "text": "It would be nice to have the car lines redone. Also i understand rent goes up. But why does it have to go up every renewal. When i moved in here going on 4 years it was 879 month. Now its 1287 that's crazy. I just feel like im getting pushed out. Im a single person and checks can't keep up. Just wanted to give my opinion. I love living here and would like to keep living here. Thanks for your time. Thomas Wisniewski",
      "date": "2024-06-13",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_991220c1-0386-46d2-a8ba-1745d97ab884",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019e8718-8819-738b-8958-c9d9a5a696d2.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Exterior view of the community building with picnic tables and a grassy courtyard.",
        "public_id": "019e8718-8819-738b-8958-c9d9a5a696d2",
        "storage_key": "property/6767906449166328/019e8718-8819-738b-8958-c9d9a5a696d2.webp",
        "width": 2000,
        "height": 1000
      },
      "virtual_tour_title": " Liberty Pointe Amenities",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com/?tour=6378555e4a84cf3284840e56&sourceId=1001"
    },
    {
      "id": "custom_ad0dd977-2f0e-417f-a57e-acfb15a98ec6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/019d0269-6ea6-72bd-b2d9-c4424e364858.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Living room with carpet and large window",
        "public_id": "019d0269-6ea6-72bd-b2d9-c4424e364858",
        "storage_key": "property/6767906449166328/019d0269-6ea6-72bd-b2d9-c4424e364858.webp",
        "width": 1920,
        "height": 1080
      },
      "virtual_tour_title": "2BR, 2BA - 855 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=1yQ3kmdFxBU"
    }
  ],
  "faqs": [],
  "fees": [
    {
      "id": "ec_caedd8a01b4994d3a0f5e67d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "engrain",
      "external_id": "429269",
      "name": "Month To Month Fee",
      "description": "false",
      "amount": 350,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_2729e41e8318a53e8deefe27",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "engrain",
      "external_id": "429270",
      "name": "Pet Deposit",
      "description": "false",
      "amount": 350,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at move-in",
      "category": "pets_other",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": true,
      "is_taxable": false
    },
    {
      "id": "ec_93eab47d6119b11d41aeed85",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "engrain",
      "external_id": "429271",
      "name": "Application Fee",
      "description": "Per applicant.",
      "amount": 75,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at application",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_fffa40ec8bbc6f6e6083aee3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "engrain",
      "external_id": "429272",
      "name": "Pet Rent",
      "description": "false",
      "amount": 50,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly, due at move-in",
      "category": "pets_other",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_f39fc1247ad8e26417fc3208",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "engrain",
      "external_id": "429274",
      "name": "Reservation Fee",
      "description": "false",
      "amount": 200,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at application",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_152f1bba3425adc96826ce6d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "engrain",
      "external_id": "429275",
      "name": "Amenity Fee",
      "description": "false",
      "amount": 75,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at move-in",
      "category": "community",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_1d6f4fc8feedae69c1917f86",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "engrain",
      "external_id": "429276",
      "name": "Transfer Fee",
      "description": "Transfer fee is 50% of rent; minimum $500",
      "amount": 500,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Per occurrence",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_9395d13fdb92a8ba76b9f2e1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "engrain",
      "external_id": "429277",
      "name": "Security Deposit",
      "description": "Deposit amount applies with approved credit and may be higher for conditional approvals.",
      "amount": 750,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at move-in",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": true,
      "is_taxable": false
    },
    {
      "id": "ec_5e666562bfe5b4a5387b6796",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "engrain",
      "external_id": "543055",
      "name": "Utility - Electric Service",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Usage-Based (Utilities)",
      "amount_type": "text",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_8da49da815ed150c4dca3ab6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "engrain",
      "external_id": "543059",
      "name": "Utility - Gas Service",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Usage-Based (Utilities)",
      "amount_type": "text",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_73239395fb4ae67a98542762",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "engrain",
      "external_id": "835113",
      "name": "Buy-Out Fee",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "One Month's Rent",
      "amount_type": "text",
      "timing": "One-time",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_a45e9428276033d2f7384fb0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "engrain",
      "external_id": "835115",
      "name": "NSF/Returned Check Fee",
      "description": "false",
      "amount": 50,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Per occurrence",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_2a96887d152daff613a1188f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "engrain",
      "external_id": "835116",
      "name": "Amenity Fee - Renewal",
      "description": "false",
      "amount": 75,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Annually, due at move-in",
      "category": "community",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_39a3e0adb4385003b9ac067c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "engrain",
      "external_id": "835127",
      "name": "Late Fee",
      "description": "false",
      "amount": 5,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "percentage",
      "timing": "Per occurrence",
      "category": "penalties",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_0c7bc5bc8247f96c4643b968",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "engrain",
      "external_id": "838630",
      "name": "Utility - Water/Sewer Service",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Usage-Based (Utilities)",
      "amount_type": "text",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    }
  ],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019a283c-3c0e-7332-8590-96312f1d316d",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "aion-liberty-pointe-auto",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328"
    },
    {
      "lead_collector_id": "019c3043-7013-706f-a0e2-21a4a8c2925a",
      "lead_source": "FACEBOOK_ADS",
      "name": "liberty-pointe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328"
    },
    {
      "lead_collector_id": "019c3043-7086-760f-9c69-120acc078934",
      "lead_source": "LANDING_PAGE",
      "name": "liberty-pointe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "page_item_url": "pet-friendly-apartments-newark-de-96",
      "search_query": "pet friendly apartments in Newark DE",
      "category": "Amenity",
      "h1_title": "Pet Friendly Apartments in Newark, DE",
      "h2_subtitle": "Discover pet-friendly living at Liberty Pointe. Our Newark, DE apartments welcome your furry friends with neighborhood conveniences just steps away.",
      "page_copy": "At Liberty Pointe, your pets are as welcome as you are. As one of the top pet friendly apartments in Newark, DE, we pride ourselves on offering both you and your furry companions a comfortable and enjoyable living experience. Our expansive dog park is perfect for playtime and ensures plenty of outdoor fun without leaving the community.\n\nNestled in Newark, DE, Liberty Pointe provides a modern yet cozy atmosphere. Choose from our newly renovated studio, one or two-bedroom apartments featuring amenities like central air conditioning and black appliances. Just minutes from the Christiana Mall and within reach of local parks, our location makes it easy to embrace a pet-friendly lifestyle. Visit us today and see how Liberty Pointe can become the perfect home for you and your four-legged friend!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/01a015da-70e9-74b8-9417-1e7d70cadbfa.webp",
      "featured_image_media": {
        "alt_text": "Exterior of a brick apartment building with parking lot and green lawn.",
        "public_id": "01a015da-70e9-74b8-9417-1e7d70cadbfa",
        "storage_key": "property/6767906449166328/01a015da-70e9-74b8-9417-1e7d70cadbfa.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet Friendly Apartments in Newark, DE",
      "seo_description": "Find pet-friendly living at Liberty Pointe with spacious amenities and a dog park in Newark, DE. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "page_item_url": "apartments-in-home-washer-dryer-christiana-mall-784",
      "search_query": "apartments with in-home washer dryer near Christiana Mall",
      "category": "Amenity",
      "h1_title": "Apartments with In-Home Washer Dryer",
      "h2_subtitle": "Enjoy the luxury of apartments with in-home washer dryer near Christiana Mall. Experience Liberty Pointe's modern conveniences in Newark, DE.",
      "page_copy": "Liberty Pointe offers stylish apartments with in-home washer and dryer units just minutes away from Christiana Mall, providing the ultimate in convenience and comfort. Living here means you'll enjoy the perks of modern living in Newark, DE while staying close to one of the area's premier shopping destinations.\n\nOur beautifully renovated apartments feature central air conditioning, espresso cabinets, and black appliances, as well as a washer and dryer in each unit. Located in the vibrant Newark community, Liberty Pointe not only offers luxurious amenities but also provides easy access to shopping, dining, and entertainment at Christiana Mall. Discover a lifestyle of ease and convenience by joining our vibrant community today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/01a015da-70e9-74b8-9417-1e7d70cadbfa.webp",
      "featured_image_media": {
        "alt_text": "Exterior of a brick apartment building with parking lot and green lawn.",
        "public_id": "01a015da-70e9-74b8-9417-1e7d70cadbfa",
        "storage_key": "property/6767906449166328/01a015da-70e9-74b8-9417-1e7d70cadbfa.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with In-Home Washer Dryer",
      "seo_description": "Find apartments with in-home washer dryer near Christiana Mall. Choose Liberty Pointe in Newark, DE and enjoy convenience and comfort.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "page_item_url": "dog-park-apartments-new-castle-county-477",
      "search_query": "dog park apartments in New Castle County",
      "category": "Amenity",
      "h1_title": "Dog Park Apartments in New Castle County",
      "h2_subtitle": "Explore Liberty Pointe's dog park apartments. Located in New Castle County, our community offers a haven for you and your pets.",
      "page_copy": "Embrace the perfect pet-friendly lifestyle at Liberty Pointe, offering dog park apartments in New Castle County. Our community is designed with pet lovers in mind, featuring an expansive dog park right within our grounds, providing the ideal spot for your furry friends to play and socialize.\n\nLocated in Newark, DE, Liberty Pointe combines modern apartment living with pet-friendly amenities. Our newly renovated studio, one, and two-bedroom apartments offer features such as central air conditioning and contemporary black appliances. With the convenience of being just a short drive from Christiana Mall and other local highlights, Liberty Pointe is the quintessential place for both you and your pets to call home. Schedule a tour today and discover how Liberty Pointe is perfect for your entire family!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/01a015da-70e9-74b8-9417-1e7d70cadbfa.webp",
      "featured_image_media": {
        "alt_text": "Exterior of a brick apartment building with parking lot and green lawn.",
        "public_id": "01a015da-70e9-74b8-9417-1e7d70cadbfa",
        "storage_key": "property/6767906449166328/01a015da-70e9-74b8-9417-1e7d70cadbfa.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog Park Apartments in New Castle County",
      "seo_description": "Discover dog park apartments in New Castle County at Liberty Pointe. Enjoy pet-friendly living in Newark, DE, with amenities for you and your pets.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "page_item_url": "energy-efficient-apartments-newark-de-322",
      "search_query": "energy-efficient apartments Newark DE",
      "category": "Amenity",
      "h1_title": "Energy-Efficient Apartments in Newark, DE",
      "h2_subtitle": "Liberty Pointe offers energy-efficient apartments. Experience eco-friendly living in Newark, DE with modern amenities and stylish designs.",
      "page_copy": "Discover the perfect blend of style and sustainability at Liberty Pointe, offering energy-efficient apartments in Newark, DE. Our community is designed to provide you with a comfortable and eco-friendly lifestyle, featuring updated units that help conserve energy while maximizing comfort.\n\nAt Liberty Pointe, you'll enjoy modern living with features such as central air conditioning, black appliances, and chic espresso cabinets. Located just minutes from the Christiana Mall and local attractions, our apartments offer not only energy efficiency but also the convenience of a prime location in Newark, DE. Join us at Liberty Pointe and enjoy a sustainable lifestyle in a vibrant community. Schedule a visit today and find your ideal energy-efficient home!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/01a015da-70e9-74b8-9417-1e7d70cadbfa.webp",
      "featured_image_media": {
        "alt_text": "Exterior of a brick apartment building with parking lot and green lawn.",
        "public_id": "01a015da-70e9-74b8-9417-1e7d70cadbfa",
        "storage_key": "property/6767906449166328/01a015da-70e9-74b8-9417-1e7d70cadbfa.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Energy-Efficient Apartments in Newark, DE",
      "seo_description": "Find energy-efficient apartments in Newark, DE at Liberty Pointe. Enjoy eco-friendly living with modern amenities just minutes from Christiana Mall.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "page_item_url": "modern-apartments-air-conditioning-newark-19702-263",
      "search_query": "modern apartments with air conditioning Newark 19702",
      "category": "Amenity",
      "h1_title": "Modern Apartments in Newark 19702",
      "h2_subtitle": "Explore modern apartments with air conditioning in Newark, 19702. Liberty Pointe offers stylish living with comfort and convenience.",
      "page_copy": "Step into comfort and style at Liberty Pointe, offering modern apartments with air conditioning in the heart of Newark, 19702. Our community is ideal for anyone seeking both contemporary design and comfort, featuring renovated living spaces equipped with central air conditioning to ensure a pleasant environment year-round.\n\nLiberty Pointe's stylish apartments offer a blend of luxury and convenience with black appliances and espresso cabinets, all set within a vibrant Newark community. Just five minutes from Christiana Mall, our location provides unmatched access to shopping, dining, and entertainment. With on-site amenities like a fitness center and a dog park, Liberty Pointe is the perfect choice for those looking to enjoy modern living with a touch of luxury. Schedule your tour today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/01a015da-70e9-74b8-9417-1e7d70cadbfa.webp",
      "featured_image_media": {
        "alt_text": "Exterior of a brick apartment building with parking lot and green lawn.",
        "public_id": "01a015da-70e9-74b8-9417-1e7d70cadbfa",
        "storage_key": "property/6767906449166328/01a015da-70e9-74b8-9417-1e7d70cadbfa.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Modern Apartments in Newark 19702",
      "seo_description": "Find modern apartments with air conditioning in Newark, 19702 at Liberty Pointe. Enjoy stylish living near Christiana Mall.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "page_item_url": "one-bedroom-apartments-newark-de-525",
      "search_query": "one bedroom apartments newark de",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Newark, DE",
      "h2_subtitle": "Discover the charm of one bedroom apartments at Liberty Pointe in Newark, DE. Experience modern living with upgraded amenities.",
      "page_copy": "Welcome to Liberty Pointe, where we offer charming one bedroom apartments in Newark, DE. Our community is designed for those seeking a stylish and comfortable living experience, with apartments featuring modern designs and exceptional amenities.\n\nLocated in the vibrant city of Newark, Liberty Pointe provides central air conditioning and beautiful black appliances, all within a community that includes a fitness center and a dog park. Situated just a short drive from Christiana Mall, our one bedroom apartments provide easy access to shopping and entertainment options. Whether you're a young professional or someone looking to downsize, Liberty Pointe offers the perfect one bedroom home in a dynamic neighborhood. Visit us today to see all that we have to offer!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/01a015da-70e9-74b8-9417-1e7d70cadbfa.webp",
      "featured_image_media": {
        "alt_text": "Exterior of a brick apartment building with parking lot and green lawn.",
        "public_id": "01a015da-70e9-74b8-9417-1e7d70cadbfa",
        "storage_key": "property/6767906449166328/01a015da-70e9-74b8-9417-1e7d70cadbfa.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Newark, DE",
      "seo_description": "Explore one bedroom apartments in Newark, DE at Liberty Pointe. Enjoy modern amenities and convenient location near Christiana Mall.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "page_item_url": "two-bedroom-apartments-new-castle-county-919",
      "search_query": "two bedroom apartments new castle county",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in New Castle County",
      "h2_subtitle": "Discover spacious two bedroom apartments at Liberty Pointe in New Castle County. Enjoy modern amenities in a vibrant community.",
      "page_copy": "Experience the perfect blend of space and comfort at Liberty Pointe, where we offer spacious two bedroom apartments in New Castle County. Our stylish apartments boast modern upgrades and ample living space, ideal for families and roommates alike.\n\nLocated in the vibrant area of Newark, Liberty Pointe provides residents with modern amenities including central air conditioning, a fitness center, and a playful dog park. Just minutes from Christiana Mall, our community offers convenient access to the best shopping and entertainment in the area. Embrace a relaxed lifestyle with a touch of sophistication at Liberty Pointe's two bedroom apartments—your ideal home awaits in New Castle County. Schedule a tour today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/01a015da-70e9-74b8-9417-1e7d70cadbfa.webp",
      "featured_image_media": {
        "alt_text": "Exterior of a brick apartment building with parking lot and green lawn.",
        "public_id": "01a015da-70e9-74b8-9417-1e7d70cadbfa",
        "storage_key": "property/6767906449166328/01a015da-70e9-74b8-9417-1e7d70cadbfa.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in New Castle County",
      "seo_description": "Find spacious two bedroom apartments in New Castle County at Liberty Pointe. Enjoy modern living close to Christiana Mall in Newark.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "page_item_url": "studio-apartments-near-19702-541",
      "search_query": "studio apartments near 19702",
      "category": "Floorplan",
      "h1_title": "Studio Apartments Near 19702",
      "h2_subtitle": "Explore stylish studio apartments near 19702 at Liberty Pointe. Enjoy modern living with great amenities in a vibrant environment.",
      "page_copy": "Discover the charm and convenience of studio apartments near 19702 at Liberty Pointe. Our community offers a sophisticated living experience with contemporary studio layouts that maximize space and comfort.\n\nLocated in the heart of Newark, our residents benefit from an array of amenities such as a dog park, playground, and fitness center, perfect for staying active and social. With modern features like central air conditioning and sleek black appliances, Liberty Pointe ensures a comfortable urban living experience. Plus, with proximity to Christiana Mall, shopping and dining options are never far away. Come see why Liberty Pointe's studio apartments are the perfect blend of style and convenience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/01a015da-70e9-74b8-9417-1e7d70cadbfa.webp",
      "featured_image_media": {
        "alt_text": "Exterior of a brick apartment building with parking lot and green lawn.",
        "public_id": "01a015da-70e9-74b8-9417-1e7d70cadbfa",
        "storage_key": "property/6767906449166328/01a015da-70e9-74b8-9417-1e7d70cadbfa.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Studio Apartments Near 19702",
      "seo_description": "Find stylish studio apartments near 19702 at Liberty Pointe. Enjoy modern amenities and a prime location in Newark.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "page_item_url": "apartments-near-thurgood-marshall-elementary-newark-de-738",
      "search_query": "apartments near thurgood marshall elementary school newark de",
      "category": "School",
      "h1_title": "Apartments Near Thurgood Marshall Elementary",
      "h2_subtitle": "Discover modern apartments near Thurgood Marshall Elementary School in Newark, DE. Enjoy a family-friendly community at Liberty Pointe.",
      "page_copy": "At Liberty Pointe, find the perfect home with our apartments near Thurgood Marshall Elementary School in Newark, DE. Ideal for families, our community offers convenience and modern living with a selection of studio, one, and two-bedroom apartments that cater to your needs.\n\nOur residents enjoy top-tier amenities such as a playground and a welcoming dog park, perfect for family fun and relaxation. Our location provides easy access to quality schools and is also just a short drive to Christiana Mall, making shopping convenient and hassle-free. Embrace a vibrant community atmosphere while enjoying contemporary features like central air conditioning and black appliances at Liberty Pointe, your future home in Newark.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/01a015da-70e9-74b8-9417-1e7d70cadbfa.webp",
      "featured_image_media": {
        "alt_text": "Exterior of a brick apartment building with parking lot and green lawn.",
        "public_id": "01a015da-70e9-74b8-9417-1e7d70cadbfa",
        "storage_key": "property/6767906449166328/01a015da-70e9-74b8-9417-1e7d70cadbfa.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Thurgood Marshall Elementary",
      "seo_description": "Explore family-friendly apartments near Thurgood Marshall Elementary in Newark, DE. Modern living at Liberty Pointe with top amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "page_item_url": "liberty-pointe-apartments-near-henry-m-brader-elementary-692",
      "search_query": "liberty pointe apartments close to henry m. brader elementary school",
      "category": "School",
      "h1_title": "Liberty Pointe: Near Henry M. Brader Elementary",
      "h2_subtitle": "Enjoy living at Liberty Pointe, conveniently located close to Henry M. Brader Elementary School in Newark, DE. A perfect community for families.",
      "page_copy": "Welcome to Liberty Pointe, where you'll find comfortable living spaces ideally situated near Henry M. Brader Elementary School. Our community's proximity to this esteemed school makes Liberty Pointe an attractive option for families seeking convenience and modern living accommodations in Newark, DE.\n\nChoose from a variety of apartment layouts, including studios and two-bedroom options, each featuring modern designs and access to our exceptional amenities such as a fitness center and dedicated dog park. The location not only provides quick access to local schools but also to shopping destinations like Christiana Mall. Discover the perfect balance of family-oriented lifestyle and contemporary apartment living at Liberty Pointe.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/01a015da-70e9-74b8-9417-1e7d70cadbfa.webp",
      "featured_image_media": {
        "alt_text": "Exterior of a brick apartment building with parking lot and green lawn.",
        "public_id": "01a015da-70e9-74b8-9417-1e7d70cadbfa",
        "storage_key": "property/6767906449166328/01a015da-70e9-74b8-9417-1e7d70cadbfa.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Liberty Pointe: Near Henry M. Brader Elementary",
      "seo_description": "Live at Liberty Pointe, close to Henry M. Brader Elementary. Family-friendly apartments in Newark, DE with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "page_item_url": "apartments-near-may-b-leasure-elementary-115",
      "search_query": "may b. leasure elementary school nearby apartments",
      "category": "School",
      "h1_title": "Apartments Near May B. Leasure Elementary",
      "h2_subtitle": "Find modern apartments near May B. Leasure Elementary School. Liberty Pointe offers a convenient and family-friendly community in Newark, DE.",
      "page_copy": "If you're searching for a home in Newark, DE, look no further than Liberty Pointe, offering excellent apartments near May B. Leasure Elementary School. Our community is designed with families in mind, providing proximity to quality education alongside modern conveniences.\n\nAt Liberty Pointe, you can choose from studio, one, or two-bedroom apartments that feature stylish designs and useful amenities, such as a playground and a dedicated fitness center. Residents enjoy a seamless blend of comfort and accessibility, with quick access to Christiana Mall for shopping and leisure. Experience the vibrant and welcoming atmosphere at Liberty Pointe, the ideal choice for families looking for apartments near educational facilities and city amenities.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/01a015da-70e9-74b8-9417-1e7d70cadbfa.webp",
      "featured_image_media": {
        "alt_text": "Exterior of a brick apartment building with parking lot and green lawn.",
        "public_id": "01a015da-70e9-74b8-9417-1e7d70cadbfa",
        "storage_key": "property/6767906449166328/01a015da-70e9-74b8-9417-1e7d70cadbfa.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near May B. Leasure Elementary",
      "seo_description": "Discover family-friendly apartments near May B. Leasure Elementary at Liberty Pointe in Newark, DE. Convenient living with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "page_item_url": "apartments-near-william-b-keene-elementary-994",
      "search_query": "local apartments around william b. keene elementary school new castle county",
      "category": "School",
      "h1_title": "Local Apartments by William B. Keene Elementary",
      "h2_subtitle": "Explore Liberty Pointe's local apartments around William B. Keene Elementary School in New Castle County, ideal for families in Newark, DE.",
      "page_copy": "Liberty Pointe offers the perfect location for families seeking local apartments around William B. Keene Elementary School in New Castle County. Nestled in the vibrant community of Newark, DE, our apartments are designed with both comfort and convenience in mind.\n\nChoose from a selection of studio, one, or two-bedroom apartment homes that feature modern designs and desirable amenities, such as a welcoming dog park and a fully equipped fitness center. The close proximity to William B. Keene Elementary provides ease for families, while being just minutes from Christiana Mall ensures shopping and entertainment are never far away. Enjoy the blend of community and comfort at Liberty Pointe, where family-friendly living is redefined.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/01a015da-70e9-74b8-9417-1e7d70cadbfa.webp",
      "featured_image_media": {
        "alt_text": "Exterior of a brick apartment building with parking lot and green lawn.",
        "public_id": "01a015da-70e9-74b8-9417-1e7d70cadbfa",
        "storage_key": "property/6767906449166328/01a015da-70e9-74b8-9417-1e7d70cadbfa.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Local Apartments by William B. Keene Elementary",
      "seo_description": "Find local apartments near William B. Keene Elementary at Liberty Pointe in New Castle County. Family-friendly and conveniently located.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "page_item_url": "apartments-near-shue-medill-middle-school-105",
      "search_query": "apartments close to shue-medill middle school newark",
      "category": "School",
      "h1_title": "Apartments Near Shue-Medill Middle School",
      "h2_subtitle": "Discover Liberty Pointe's apartments close to Shue-Medill Middle School in Newark, DE. A perfect mix of convenience and comfort for families.",
      "page_copy": "Welcome to Liberty Pointe, your top choice for apartments close to Shue-Medill Middle School in Newark, DE. Our community offers an ideal living environment for families, providing easy access to educational facilities and a host of modern amenities.\n\nAt Liberty Pointe, residents can select from stylish studio, one, or two-bedroom apartments, each thoughtfully designed for contemporary living. Enjoy community amenities such as a fitness center, a dog park, and quick access to nearby shopping at Christiana Mall. Relish the convenience of living in a prime location that combines access to quality education with exceptional comfort and lifestyle offerings. Discover family-friendly living at its best at Liberty Pointe.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/01a015da-70e9-74b8-9417-1e7d70cadbfa.webp",
      "featured_image_media": {
        "alt_text": "Exterior of a brick apartment building with parking lot and green lawn.",
        "public_id": "01a015da-70e9-74b8-9417-1e7d70cadbfa",
        "storage_key": "property/6767906449166328/01a015da-70e9-74b8-9417-1e7d70cadbfa.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Shue-Medill Middle School",
      "seo_description": "Liberty Pointe offers apartments near Shue-Medill Middle School in Newark, DE. Enjoy convenient, family-friendly living with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "page_item_url": "glasgow-high-school-nearby-apartments-122",
      "search_query": "glasgow high school nearby apartments new castle county",
      "category": "School",
      "h1_title": "Nearby Apartments to Glasgow High School",
      "h2_subtitle": "Explore Liberty Pointe's nearby apartments to Glasgow High School in New Castle County. Experience modern living with excellent amenities.",
      "page_copy": "Liberty Pointe provides a wonderful residential option for those seeking nearby apartments to Glasgow High School in New Castle County. Our community is situated in the vibrant area of Newark, DE, ideal for families wanting proximity to educational institutions.\n\nChoose from our sophisticated studio, one, or two-bedroom apartments all equipped with contemporary features and access to exceptional facilities, including a playground and black appliances. Being minutes from Christiana Mall, Liberty Pointe blends convenience and comfort seamlessly, making it a perfect choice for families and professionals alike. Discover the ease and enjoyment of a well-rounded lifestyle at Liberty Pointe, where being close to Glasgow High School is just one of the many advantages.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/01a015da-70e9-74b8-9417-1e7d70cadbfa.webp",
      "featured_image_media": {
        "alt_text": "Exterior of a brick apartment building with parking lot and green lawn.",
        "public_id": "01a015da-70e9-74b8-9417-1e7d70cadbfa",
        "storage_key": "property/6767906449166328/01a015da-70e9-74b8-9417-1e7d70cadbfa.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Nearby Apartments to Glasgow High School",
      "seo_description": "Find nearby apartments to Glasgow High School at Liberty Pointe in New Castle County. Enjoy modern living with easy access to education.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "page_item_url": "apartments-near-newark-charter-senior-high-343",
      "search_query": "find apartments near newark charter senior high school",
      "category": "School",
      "h1_title": "Find Apartments Near Newark Charter High",
      "h2_subtitle": "Discover Liberty Pointe's apartments close to Newark Charter Senior High School. Enjoy modern comfort and convenience in Newark, DE.",
      "page_copy": "If you're looking to find apartments near Newark Charter Senior High School, Liberty Pointe offers an ideal option in Newark, DE. Perfect for families and individuals alike, our community combines a prime location with modern amenities.\n\nChoose from our spacious studio, one, or two-bedroom apartments that boast sleek renovations and features like central air conditioning and espresso cabinets. The community also includes a playground and a fitness center, ensuring a balanced lifestyle. Located just five minutes from the bustling Christiana Mall, Liberty Pointe offers residents the perfect blend of comfort, convenience, and accessibility to one of the area's top educational institutions.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/01a015da-70e9-74b8-9417-1e7d70cadbfa.webp",
      "featured_image_media": {
        "alt_text": "Exterior of a brick apartment building with parking lot and green lawn.",
        "public_id": "01a015da-70e9-74b8-9417-1e7d70cadbfa",
        "storage_key": "property/6767906449166328/01a015da-70e9-74b8-9417-1e7d70cadbfa.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Find Apartments Near Newark Charter High",
      "seo_description": "Explore Liberty Pointe's apartments near Newark Charter Senior High School. Enjoy modern, convenient living in Newark, DE.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "page_item_url": "apartments-near-university-of-delaware-242",
      "search_query": "apartments close to university of delaware newark",
      "category": "School",
      "h1_title": "Apartments Close to University of Delaware",
      "h2_subtitle": "Discover Liberty Pointe's apartments near the University of Delaware. Enjoy the benefits of modern living in vibrant Newark, DE.",
      "page_copy": "Looking for apartments close to the University of Delaware in Newark? Liberty Pointe presents an excellent living choice for students and faculty alike. Our community offers a strategic location adjacent to the university, accompanied by a rich selection of amenities.\n\nLiberty Pointe features studio, one, or two-bedroom apartments, each designed to cater to contemporary lifestyles with features like black appliances and central air conditioning. Residents can enjoy a variety of amenities including a dog park and fitness center, perfect for unwinding after a day of classes. Located within easy reach of Christiana Mall, our community ensures that leisure and necessities are always close by, making it the ideal home base for university life.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/01a015da-70e9-74b8-9417-1e7d70cadbfa.webp",
      "featured_image_media": {
        "alt_text": "Exterior of a brick apartment building with parking lot and green lawn.",
        "public_id": "01a015da-70e9-74b8-9417-1e7d70cadbfa",
        "storage_key": "property/6767906449166328/01a015da-70e9-74b8-9417-1e7d70cadbfa.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to University of Delaware",
      "seo_description": "Liberty Pointe offers apartments near the University of Delaware, combining convenience and modern living in Newark, DE.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "page_item_url": "apartments-near-christianacare-hospital-newark-774",
      "search_query": "apartments near ChristianaCare Hospital Newark DE",
      "category": "Hospital",
      "h1_title": "Apartments Near ChristianaCare Hospital",
      "h2_subtitle": "Discover Liberty Pointe's exceptional apartments near ChristianaCare Hospital in Newark, DE. Enjoy convenient and comfortable living.",
      "page_copy": "Liberty Pointe is an ideal choice for those searching for apartments near ChristianaCare Hospital in Newark, DE. Our community offers an unbeatable location combined with modern amenities, making it perfect for healthcare professionals and anyone needing close proximity to the hospital.\n\nChoose from thoughtfully designed studio, one, or two-bedroom apartments featuring stylish renovations, such as central air conditioning and high-end black appliances. Our on-site amenities like a dog park and playground further enhance your living experience. Situated just five minutes from Christiana Mall, Liberty Pointe ensures that shopping, dining, and entertainment options are easily accessible, providing a balanced lifestyle for residents who value convenience and comfort.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/01a015da-70e9-74b8-9417-1e7d70cadbfa.webp",
      "featured_image_media": {
        "alt_text": "Exterior of a brick apartment building with parking lot and green lawn.",
        "public_id": "01a015da-70e9-74b8-9417-1e7d70cadbfa",
        "storage_key": "property/6767906449166328/01a015da-70e9-74b8-9417-1e7d70cadbfa.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near ChristianaCare Hospital Newark",
      "seo_description": "Liberty Pointe offers apartments near ChristianaCare Hospital in Newark, DE. Enjoy modern living with convenient access to healthcare amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "page_item_url": "apartments-near-william-m-redd-jr-park-newark-361",
      "search_query": "apartments near William M. Redd Jr. Park Newark",
      "category": "Park",
      "h1_title": "Apartments Near William M. Redd Jr. Park",
      "h2_subtitle": "Explore Liberty Pointe's proximity to William M. Redd Jr. Park in Newark, DE. Enjoy community features that complement your active lifestyle.",
      "page_copy": "Looking for apartments near William M. Redd Jr. Park in Newark, DE? Liberty Pointe offers a serene environment with modern amenities just a short distance from this popular local park. Perfect for adventure seekers and nature lovers, our community provides easy access to outdoor activities.\n\nLiberty Pointe boasts studio, one, and two-bedroom apartments featuring stylish renovations, such as espresso cabinets and black appliances, catering to contemporary tastes. Residents enjoy a range of on-site amenities, including a playground and a fitness center, ideal for maintaining an active lifestyle. With Christiana Mall nearby, both recreation and convenience are at your doorstep, making Liberty Pointe a prime choice for those who cherish both nature and modern comfort.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/01a015da-70e9-74b8-9417-1e7d70cadbfa.webp",
      "featured_image_media": {
        "alt_text": "Exterior of a brick apartment building with parking lot and green lawn.",
        "public_id": "01a015da-70e9-74b8-9417-1e7d70cadbfa",
        "storage_key": "property/6767906449166328/01a015da-70e9-74b8-9417-1e7d70cadbfa.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near William M. Redd Jr. Park Newark",
      "seo_description": "Liberty Pointe offers modern apartments near William M. Redd Jr. Park, Newark, DE, providing a perfect blend of outdoor access and contemporary living.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "page_item_url": "liberty-pointe-near-kershaw-park-de-454",
      "search_query": "Liberty Pointe apartments close to Kershaw Park DE",
      "category": "Park",
      "h1_title": "Liberty Pointe Apartments Near Kershaw Park",
      "h2_subtitle": "Discover Liberty Pointe apartments close to Kershaw Park, DE. Experience modern living with natural beauty at your doorstep.",
      "page_copy": "Liberty Pointe in Newark, DE, offers an exceptional residential experience with its proximity to Kershaw Park. Perfect for those who love being near green spaces, our community features stylishly renovated studio, one, and two-bedroom apartments.\n\nResidents of Liberty Pointe enjoy a suite of amenities including a fitness center and a dog park, ideal for pet owners and fitness enthusiasts. Each apartment is equipped with contemporary features like espresso cabinets and central air conditioning, providing comfort and style. Located just minutes from Christiana Mall, Liberty Pointe offers the perfect blend of nature and convenience, making it an ideal home for those who treasure both outdoor and urban lifestyles.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/01a015da-70e9-74b8-9417-1e7d70cadbfa.webp",
      "featured_image_media": {
        "alt_text": "Exterior of a brick apartment building with parking lot and green lawn.",
        "public_id": "01a015da-70e9-74b8-9417-1e7d70cadbfa",
        "storage_key": "property/6767906449166328/01a015da-70e9-74b8-9417-1e7d70cadbfa.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Liberty Pointe Apartments Near Kershaw Park",
      "seo_description": "Discover modern living at Liberty Pointe, near Kershaw Park, DE. Enjoy proximity to nature and city conveniences.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "page_item_url": "curtis-mill-park-nearby-liberty-pointe-rentals-124",
      "search_query": "Curtis Mill Park nearby Liberty Pointe rentals",
      "category": "Park",
      "h1_title": "Curtis Mill Park Nearby Liberty Pointe",
      "h2_subtitle": "Enjoy Liberty Pointe rentals with Curtis Mill Park nearby in Newark, DE. Experience the perfect mix of nature and modern amenities.",
      "page_copy": "At Liberty Pointe in Newark, DE, you'll find a perfect combination of modern living and nature with Curtis Mill Park just a short distance away. Our community is ideal for those who appreciate the outdoors while wanting contemporary comforts.\n\nLiberty Pointe offers a variety of floor plans, including studio, one, and two-bedroom apartments, complete with stylish renovations such as black appliances and central air conditioning. On-site amenities like the fitness center and playground ensure plenty of recreational opportunities. Located conveniently, just minutes from Christiana Mall, residents enjoy easy access to shopping, dining, and entertainment options, making Liberty Pointe a fantastic choice for a balanced lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/01a015da-70e9-74b8-9417-1e7d70cadbfa.webp",
      "featured_image_media": {
        "alt_text": "Exterior of a brick apartment building with parking lot and green lawn.",
        "public_id": "01a015da-70e9-74b8-9417-1e7d70cadbfa",
        "storage_key": "property/6767906449166328/01a015da-70e9-74b8-9417-1e7d70cadbfa.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Curtis Mill Park Near Liberty Pointe Rentals",
      "seo_description": "Find Liberty Pointe rentals with Curtis Mill Park nearby in Newark, DE, offering a blend of nature and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "page_item_url": "old-paper-mill-road-park-accessible-apartments-newark-de-163",
      "search_query": "Old Paper Mill Road Park accessible apartments in Newark DE",
      "category": "Park",
      "h1_title": "Accessible Apartments Near Old Paper Mill Road Park",
      "h2_subtitle": "Find accessible apartments near Old Paper Mill Road Park in Newark, DE. Liberty Pointe offers modern living close to nature and city conveniences.",
      "page_copy": "Located in Newark, DE, Liberty Pointe offers accessible apartments near Old Paper Mill Road Park, making it ideal for those who love outdoor activities without sacrificing modern comforts. Our community welcomes residents with a selection of contemporary studio, one, and two-bedroom units designed for convenience and style.\n\nLiberty Pointe features top-tier amenities like a fitness center and dog park, providing excellent spaces for relaxation and exercise. The apartments come equipped with central air conditioning and stylish details such as espresso cabinets. Just five minutes from Christiana Mall, Liberty Pointe provides residents easy access to both shopping and nature, catering to a well-rounded, dynamic lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/01a015da-70e9-74b8-9417-1e7d70cadbfa.webp",
      "featured_image_media": {
        "alt_text": "Exterior of a brick apartment building with parking lot and green lawn.",
        "public_id": "01a015da-70e9-74b8-9417-1e7d70cadbfa",
        "storage_key": "property/6767906449166328/01a015da-70e9-74b8-9417-1e7d70cadbfa.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Accessible Apartments Near Old Paper Mill Road Park",
      "seo_description": "Discover Liberty Pointe's accessible apartments near Old Paper Mill Road Park, Newark, DE, blending modern living with nature nearby.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "page_item_url": "rentals-near-judge-morris-estate-white-clay-creek-162",
      "search_query": "rentals near Judge Morris Estate White Clay Creek",
      "category": "Park",
      "h1_title": "Rentals Near Judge Morris Estate at White Clay",
      "h2_subtitle": "Explore rentals near Judge Morris Estate in White Clay Creek, conveniently located at Liberty Pointe offering modern amenities and nature access.",
      "page_copy": "Liberty Pointe offers residents exceptional rentals near the scenic Judge Morris Estate at White Clay Creek, perfect for those who treasure a blend of nature and modern living. Located in Newark, DE, our community offers beautifully renovated studio, one, and two-bedroom apartments equipped with contemporary amenities like central air conditioning and sleek black appliances.\n\nResidents at Liberty Pointe enjoy a variety of community amenities, including a well-equipped fitness center and a pet-friendly dog park. Proximity to Christiana Mall ensures easy access to shopping and dining, while the nearby natural beauty of White Clay Creek and Judge Morris Estate provides endless opportunities for outdoor activities. Embrace a lifestyle that combines convenience and tranquility at Liberty Pointe.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/01a015da-70e9-74b8-9417-1e7d70cadbfa.webp",
      "featured_image_media": {
        "alt_text": "Exterior of a brick apartment building with parking lot and green lawn.",
        "public_id": "01a015da-70e9-74b8-9417-1e7d70cadbfa",
        "storage_key": "property/6767906449166328/01a015da-70e9-74b8-9417-1e7d70cadbfa.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals Near Judge Morris Estate at White Clay",
      "seo_description": "Find rentals near Judge Morris Estate at White Clay Creek, offering Liberty Pointe's modern amenities and convenient access to nature in Newark, DE.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "page_item_url": "liberty-pointe-apts-close-to-middle-run-valley-natural-area-808",
      "search_query": "Liberty Pointe apts close to Middle Run Valley Natural Area",
      "category": "Park",
      "h1_title": "Liberty Pointe Apts Near Middle Run Valley",
      "h2_subtitle": "Discover Liberty Pointe apartments close to Middle Run Valley Natural Area. Enjoy modern living with access to beautiful natural surroundings.",
      "page_copy": "Discover the perfect blend of nature and modernity at Liberty Pointe, where our apartments are conveniently close to the Middle Run Valley Natural Area in Newark, DE. Residents enjoy easy access to stunning trails and outdoor adventures while relishing in the comfort of contemporary living.\n\nLiberty Pointe offers stylish studio, one, and two-bedroom apartments featuring sleek renovations, with amenities such as black appliances and central air conditioning. The community caters to an active lifestyle with a fitness center, playground, and pet-friendly settings. Just minutes from Christiana Mall, Liberty Pointe also provides unparalleled convenience for shopping and dining, making it the ideal choice for a balanced lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/01a015da-70e9-74b8-9417-1e7d70cadbfa.webp",
      "featured_image_media": {
        "alt_text": "Exterior of a brick apartment building with parking lot and green lawn.",
        "public_id": "01a015da-70e9-74b8-9417-1e7d70cadbfa",
        "storage_key": "property/6767906449166328/01a015da-70e9-74b8-9417-1e7d70cadbfa.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Liberty Pointe Apts Near Middle Run Valley",
      "seo_description": "Explore Liberty Pointe apartments near Middle Run Valley Natural Area, offering modern living and access to Newark's natural beauty.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "page_item_url": "apartments-in-new-castle-county-near-deacons-walk-park-827",
      "search_query": "apartments in New Castle County near Deacons Walk Park",
      "category": "Park",
      "h1_title": "Apts in New Castle County Near Deacons Walk",
      "h2_subtitle": "Find apartments near Deacons Walk Park in New Castle County. Liberty Pointe offers convenience with nature and city amenities at your doorstep.",
      "page_copy": "Situated in charming Newark, DE, Liberty Pointe offers prime apartments in New Castle County near Deacons Walk Park. Experience the tranquility of nature right next to your home, with easy access to peaceful walks and scenic views.\n\nLiberty Pointe features elegantly renovated studio, one, and two-bedroom units designed with modern conveniences like central air conditioning and espresso cabinets. Our community amenities, including a fitness center and dog park, ensure residents enjoy a balanced lifestyle of relaxation and activity. With Christiana Mall just minutes away, Liberty Pointe provides the perfect blend of nature and accessibility in a vibrant community setting.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/01a015da-70e9-74b8-9417-1e7d70cadbfa.webp",
      "featured_image_media": {
        "alt_text": "Exterior of a brick apartment building with parking lot and green lawn.",
        "public_id": "01a015da-70e9-74b8-9417-1e7d70cadbfa",
        "storage_key": "property/6767906449166328/01a015da-70e9-74b8-9417-1e7d70cadbfa.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts in New Castle Near Deacons Walk Park",
      "seo_description": "Discover Liberty Pointe's apts near Deacons Walk Park in New Castle County, offering nature-rich living with modern amenities in Newark, DE.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "page_item_url": "lewis-park-nearby-apartments-in-newark-320",
      "search_query": "Lewis Park nearby apartments in Newark",
      "category": "Park",
      "h1_title": "Apartments Near Lewis Park in Newark",
      "h2_subtitle": "Explore apartments near Lewis Park in Newark. Liberty Pointe offers convenient living with exceptional amenities close to green spaces.",
      "page_copy": "Liberty Pointe is your destination for convenient living near Lewis Park in Newark, DE. Our modern apartments provide easy access to outdoor recreation in a serene environment, ideal for those who enjoy leisure walks and family outings in nearby Lewis Park.\n\nChoose from a variety of stylishly renovated studio, one, and two-bedroom apartments, featuring black appliances and central air conditioning. Liberty Pointe's community amenities include a state-of-the-art fitness center, a dog park, and close proximity to Christiana Mall for convenient shopping and dining. Embrace the best of Newark with these apartments, perfectly situated to offer both comfort and nature.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/01a015da-70e9-74b8-9417-1e7d70cadbfa.webp",
      "featured_image_media": {
        "alt_text": "Exterior of a brick apartment building with parking lot and green lawn.",
        "public_id": "01a015da-70e9-74b8-9417-1e7d70cadbfa",
        "storage_key": "property/6767906449166328/01a015da-70e9-74b8-9417-1e7d70cadbfa.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Lewis Park in Newark",
      "seo_description": "Find Liberty Pointe apartments near Lewis Park in Newark, DE. Enjoy modern amenities with easy access to green spaces and city conveniences.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166328",
      "source": "custom",
      "page_item_url": "liberty-pointe-close-to-folk-memorial-park-de-949",
      "search_query": "Liberty Pointe close to Folk Memorial Park DE",
      "category": "Park",
      "h1_title": "Liberty Pointe Near Folk Memorial Park",
      "h2_subtitle": "Live at Liberty Pointe, close to Folk Memorial Park in DE. Experience modern amenities just steps from beautiful parkland.",
      "page_copy": "Nestled conveniently in Newark, DE, Liberty Pointe offers residents the perfect blend of urban convenience and natural beauty being close to Folk Memorial Park. Enjoy close proximity to this cherished park, perfect for picnics, leisure strolls, and community events.\n\nAt Liberty Pointe, choose from stylishly renovated studio, one, and two-bedroom apartments featuring sleek design elements like espresso cabinets and central air conditioning. Residents benefit from community features such as a fitness center, playground, and a pet-friendly environment. Plus, with the Christiana Mall only minutes away, you'll have both convenience and recreation at your fingertips right from Liberty Pointe.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166328/01a015da-70e9-74b8-9417-1e7d70cadbfa.webp",
      "featured_image_media": {
        "alt_text": "Exterior of a brick apartment building with parking lot and green lawn.",
        "public_id": "01a015da-70e9-74b8-9417-1e7d70cadbfa",
        "storage_key": "property/6767906449166328/01a015da-70e9-74b8-9417-1e7d70cadbfa.webp",
        "width": 3072,
        "height": 2048
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Liberty Pointe Near Folk Memorial Park DE",
      "seo_description": "Discover Liberty Pointe near Folk Memorial Park in DE, offering modern living with access to Newark's beautiful parks and top-notch amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "jordanh@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5065"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "9976263936"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4973402"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-NCT7RD4V"
    },
    {
      "ID": "custom_perq_script_url",
      "type": "STRING",
      "value": "https://livelibertypointe.fatwin.com/api/websites/resources/1?x=RnBYRmhNVVRTU1lsY1lDQmZXWnFhYjAvMHE3bzdaaEwrbWxZYmtLQmd0SWtBOFRNRE4xekVTaWFzLzQrcmU2V2RVR1orMElPcWMvcE12ZC9GVmZ4aUE9PQ2"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Comfy"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "47607690395"
    },
    {
      "ID": "custom_engrain_sitemap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/5evekezxvqo"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_eliseai_building_token",
      "type": "STRING",
      "value": "9548a232-43e6-11ef-85f2-a33de60b968b"
    },
    {
      "ID": "custom_eliseai_tour_scheduler",
      "type": "STRING",
      "value": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/9548a232-43e6-11ef-85f2-a33de60b968b/tour?hideScrollBars=true"
    },
    {
      "ID": "custom_eliseai_organization_id",
      "type": "STRING",
      "value": "4bbc32e5-b155-40a7-886b-b483419a5646"
    },
    {
      "ID": "custom_eliseai_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"window.eliseAi.onOpenSST()\">Schedule A Tour</button>"
    },
    {
      "ID": "custom_eliseai_tour_scheduler_url",
      "type": "STRING",
      "value": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/9548a232-43e6-11ef-85f2-a33de60b968b/tour?hideScrollBars=true"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IjFCbDViMEpLNURKSnl0OWtGbC9scEE9PSIsInZhbHVlIjoiRnRhRng4S3FRajlYV0pMbFY2bEZWdz09IiwibWFjIjoiMmJkNTMwNjExYWQyMzU0ZTJhZmI4YmM3YTA4MmNjMjA1MDJlY2Y0Yzg2Y2EzZjliYjdjZWJhMWNkODYxM2JhZSJ9"
    },
    {
      "ID": "custom_loft_resident_download_apple",
      "type": "STRING",
      "value": "https://apps.apple.com/us/app/loft-living/id333244247"
    },
    {
      "ID": "custom_loft_resident_download_google",
      "type": "STRING",
      "value": "https://play.google.com/store/apps/details?id=com.activebuilding.residents"
    }
  ],
  "custom_csm": "jordanh@repli360.com",
  "custom_qb_id": "5065",
  "custom_repli_id": "9976263936",
  "custom_realpage_id": "4973402",
  "custom_google_gtm_id": "GTM-NCT7RD4V",
  "custom_perq_script_url": "https://livelibertypointe.fatwin.com/api/websites/resources/1?x=RnBYRmhNVVRTU1lsY1lDQmZXWnFhYjAvMHE3bzdaaEwrbWxZYmtLQmd0SWtBOFRNRE4xekVTaWFzLzQrcmU2V2RVR1orMElPcWMvcE12ZC9GVmZ4aUE9PQ2",
  "custom_vibesites_theme": "Comfy",
  "custom_ads_subscription": "none",
  "custom_seo_subscription": "essential",
  "custom_hubspot_company_id": "47607690395",
  "custom_engrain_sitemap_url": "https://sightmap.com/embed/5evekezxvqo",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_eliseai_building_token": "9548a232-43e6-11ef-85f2-a33de60b968b",
  "custom_eliseai_tour_scheduler": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/9548a232-43e6-11ef-85f2-a33de60b968b/tour?hideScrollBars=true",
  "custom_eliseai_organization_id": "4bbc32e5-b155-40a7-886b-b483419a5646",
  "custom_eliseai_tour_button_popup": "<button onclick=\"window.eliseAi.onOpenSST()\">Schedule A Tour</button>",
  "custom_eliseai_tour_scheduler_url": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/9548a232-43e6-11ef-85f2-a33de60b968b/tour?hideScrollBars=true",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IjFCbDViMEpLNURKSnl0OWtGbC9scEE9PSIsInZhbHVlIjoiRnRhRng4S3FRajlYV0pMbFY2bEZWdz09IiwibWFjIjoiMmJkNTMwNjExYWQyMzU0ZTJhZmI4YmM3YTA4MmNjMjA1MDJlY2Y0Yzg2Y2EzZjliYjdjZWJhMWNkODYxM2JhZSJ9",
  "custom_loft_resident_download_apple": "https://apps.apple.com/us/app/loft-living/id333244247",
  "custom_loft_resident_download_google": "https://play.google.com/store/apps/details?id=com.activebuilding.residents",
  "custom_audioeye_site_id": "da85e407-20e2-4edb-9de1-fa5325f43790",
  "custom_audioeye_site_hash": "3f113b6088be799a4b27ff5936407b75"
};

export const generatedAt = '2026-10-22T20:07:13.085Z';
